import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { ErrorMessage, useFormik, FormikProvider, Field } from "formik";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import jsPDF from "jspdf";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import { Form, Row, Col, Table } from "react-bootstrap";
import { FaFastBackward, FaFileExcel } from "react-icons/fa";
import Swal from "sweetalert2";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { AiOutlineSearch } from "react-icons/ai";
import ShowAlert from "../../alert";
import { store } from "../../../App";
import { Link } from "@material-ui/core";

function Confirm_Emp_OnRolls() {
  const history = useHistory();
  const [bankNamesList, setbankNamesList] = useState(); const [selectedList, setSelectedList] = useState([]); const [tableenable, setTableEnable] = useState(false); const [tableData, settabledata] = useState(); const [EmpTypeList, setEmpTypeList] = useState(); const [viewEnable, setViewEnable] = useState(false); const [employeeID, setEmployeeID] = useState();
  const [prdesignationlist, setprdesignationlist] = useState(); const [selectedEmpType, setSelectedEmpType] = useState(""); const [distList, setDistList] = useState(); const [distData, setDistData] = useState([]); const [displaydist, setDisplaydist] = useState(); const [changedValues, setChangedValues] = useState({}); const [saveUser, setSaveUser] = useState(""); const [change, setChange] = useState("");

  const fieldNames = ["basic_pay_earnings", "per_pay_earnings", "spl_pay_earnings", "da_earnings", "hra_earnings", "cca_earnings", "gp_earnings", "ir_earnings", "medical_earnings", "ca_earnings", "spl_all", "misc_h_c", "addl_hra", "sca"]; const Earnings_3 = ["os_basic_pay_earnings", "os_hra_earnings", "os_medical_earnings", "os_ca_earnings", "os_performance_earnings", "os_ec_epf"]; const Deductions_3 = ["os_prof_tax_deductions", "os_ees_epf_deductions", "os_ers_epf_deductions", "os_other_deductions"];
  const Earnings_4 = ["nmr_gross_earnings"]; const Deductions_4 = ["os_prof_tax_deductions", "nmr_tds_deductions", "nmr_fa_deductions", "nmr_ea_deductions", "nmr_ma_deductions", "nmr_lic_deductions", "nmr_otherliab_deductions", "os_ees_epf_deductions", "nmr_postalrd_deductions"]; const deductionNames = ["gpfs_deductions", "gpfsa_deductions", "gpfl_deductions", "apglis_deductions", "apglil_deductions", "gis_deductions", "lic_deductions", "license_deductions", "con_decd_deductions", "epf_deductions", "epf_deductions1", "epf_l_deductions", "vpf_deductions", "ppf_deductions", "rcs_cont_deductions", "cmrf_deductions", "fcf_deductions", "house_rent_deductions", "sal_rec_deductions", "pt_deductions", "it_deductions", "other_deductions"];
  const LoanDeductions = ["car_a_loanpi", "car_a_loanti", "car_a_loan", "car_i_loanpi", "car_i_loanti", "car_i_loan", "cyc_a_loanpi", "cyc_a_loanti", "cyc_a_loan", "cyc_i_loanpi", "cyc_i_loanti", "cyc_i_loan", "mca_a_loanpi", "mca_a_loanti", "mca_a_loan", "mca_i_loanpi", "mca_i_loanti", "mca_i_loan", "mar_a_loanti", "mar_a_loanti", "mar_a_loan", "mar_i_loanpi", "mar_i_loanti", "mar_i_loan", "med_a_loanpi", "med_a_loanti", "med_a_loan", "med_a_i_loanpi", "med_a_i_loanti", "med_a_i_loan", "hba_loanpi", "hba_loanti", "hba_loan", "add_hba_loanpi", "add_hba_loanti", "add_hba_loan", "hba1_loanpi", "hba1_loanti", "hba1_loan", "add_hba1_loanpi", "add_hba1_loanti", "add_hba1_loan", "comp_loanpi", "comp_loanti", "comp_loan", "comp1_loanpi", "comp1_loanti", "comp1_loan", "hcesa_loanpi", "hcesa_loanti", "hcesa_loan", "hcesa_i_loanpi", "hcesa_i_loanti", "hcesa_i_loan", "hbao_loanpi", "hbao_loanti", "hbao_loan", "vij_bank_loanpi", "vij_bank_loanti", "vij_bank_loan", "fa_loanpi", "fa_loanti", "fa_loan", "ea_loanpi", "ea_loanti", "ea_loan", "sfa_loanpi", "sfa_loanti", "sfa_loan ", "sal_adv_loanpi", "sal_adv_loanti", "sal_adv_loan", "hr_arrear_loanpi", "hr_arrear_loanti", "hr_arrear_loan", "cell_loanpi", "cell_loanti", "cell_loan", "staff_pl_loanpi", "staff_pl_loanti", "staff_pl_loan", "court_loanpi", "court_loanti", "court_loan"];

  const formik3 = useFormik({
    initialValues: {
      emptype_id: "", district: "", working_status: "", firstname: "", lastname: "", surname: "", fathername: "", sex: "", bank_name: "", ifsc: "", totalEarnings: "", totalDeductions: "", totalloanAdvances: "", totalDeductions_3: "", totalEarnings_3: "", netSalary: "", netSalary_3: "", totalDeductions_4: "", totalEarnings_4: "", netSalary_4: "", Earnings_4: "", Deductions_4: "", basic_pay_earnings: "", per_pay_earnings: "", spl_pay_earnings: "", da_earnings: "", hra_earnings: "", cca_earnings: "", gp_earnings: "", ir_earnings: "", medical_earnings: "", ca_earnings: "", spl_all: "", misc_h_c: "", addl_hra: "", sca: "", gpfs_deductions: "", gpfsa_deductions: "", gpfl_deductions: "", apglis_deductions: "", apglil_deductions: "", gis_deductions: "", lic_deductions: "", license_deductions: "", con_decd_deductions: "", epf_deductions: "", epf_deductions1: "", epf_l_deductions: "", vpf_deductions: "", ppf_deductions: "", rcs_cont_deductions: "", cmrf_deductions: "", fcf_deductions: "", house_rent_deductions: "", sal_rec_deductions: "", pt_deductions: "", it_deductions: "", other_deductions: "", car_a_loanpi: "", cyc_a_loanpi: "", mca_a_loanpi: "", mar_a_loanpi: "", med_a_loanpi: "", hba_loanpi: "", add_hba_loanpi: "", comp_loanpi: "", hcesa_loanpi: "", hcesa_loan: "", hbao_loanpi: "", fa_loanpi: "", sfa_loanpi: "", hr_arrear_loanpi: "", staff_pl_loanpi: "", cyc_a_loanti: "", cyclePriTI: "", mca_a_loanti: "", mar_a_loanti: "", med_a_loanti: "", hba_loanti: "", add_hba_loanti: "", comp_loanti: "", hcesa_loanti: "", hbao_loanti: "", fa_loanti: "", sfa_loanti: "", hr_arrear_loanti: "", staff_pl_loanti: "",
      car_a_loan: "", cyclePriamount: "", mca_a_loan: "", mar_a_loan: "", med_a_loan: "", hba_loan: "", add_hba_loan: "", comp_loan: "", hcesaPriamount: "", hbao_loan: "", fa_loan: "", sfa_loan: "", hr_arrear_loan: "", staff_pl_loan: "", car_i_loanpi: "", cyc_i_loanpi: "", mca_i_loanpi: "", mar_i_loanpi: "", med_a_i_loanpi: "", hba1_loanpi: "", add_hba1_loanpi: "", comp1_loanti: "", hcesa_i_loanpi: "", vij_bank_loanpi: "", vij_bank_loanti: "", vij_bank_loan: "", faIntPI: "", ea_loanpi: "", sal_adv_loanpi: "", cell_loanpi: "", court_loanpi: "",
      car_i_loanti: "", cyc_i_loanti: "", mca_i_loanti: "", mar_i_loanti: "", med_a_i_loanti: "", hba1_loanti: "", add_hba1_loanti: "", comp1_loanpi: "", hcesa_i_loanti: "", hbaotherIntTI: "", faIntTI: "", ea_loanti: "", sal_adv_loanti: "", cell_loanti: "", court_loanti: "", car_i_loan: "", cyc_i_loan: "", mca_i_loan: "", mar_i_loan: "", med_a_i_loan: "", hba1_loan: "", add_hba1_loan: "", comp1_loan: "", hcesa_i_loan: "", hbaotherIntAmount: "", faIntAmount: "", ea_loan: "", sal_adv_loan: "", cell_loan: "", court_loan: "", os_location: "", os_work_place: "", os_basic_pay_earnings: "", os_hra_earnings: "", os_medical_earnings: "", os_ca_earnings: "", os_performance_earnings: "", os_ec_epf: "", os_prof_tax_deductions: "", os_ees_epf_deductions: "", os_ers_epf_deductions: "", os_other_deductions: "", nmr_gross_earnings: "", nmr_tax_deductions: "", nmr_tds_deductions: "", nmr_fa_deductions: "", nmr_ea_deductions: "", nmr_ma_deductions: "", nmr_lic_deductions: "", nmr_otherliab_deductions: "", nmr_postalrd_deductions: ""
    },
    validate: (values) => { const errors = {}; if (!values.emptype_id) { errors.emptype_id = "Select Employee Type"; } return errors; },

    onSubmit: async (values) => {
      if (values.district !== "0") { let distName = distData.filter((item) => item.code === values.district).map((item) => item.name); if (distName.length > 0) { setDisplaydist(distName[0]); } else { setDisplaydist("State"); } } else { setDisplaydist("All"); } let params = { district: values.district, emptype_id: formik3.values.emptype_id }; store.dispatch({ type: "SHOW_SPINNER" });
      await new Promise((resolve) => setTimeout(resolve, 2000)); HousingService.ConfirmEmp_OnRolls_Report(params).then((res) => { settabledata(res.data); setSelectedList(res.data.map((item) => ({ emp_id: item.emp_id, working_status: item.working_status }))); });
      setTableEnable(true); setViewEnable(false); setSelectedEmpType(""); store.dispatch({ type: "HIDE_SPINNER" });
    }
  });
  const sumFieldNames = fieldNames.reduce((total, fieldName) => total + parseFloat(formik3.values[fieldName] || 0), 0); const sumDeductions = deductionNames.reduce((total, deductionName) => total + parseFloat(formik3.values[deductionName] || 0), 0); const sumLoanDeductions = LoanDeductions.reduce((total, LoanDeduction) => total + parseFloat(formik3.values[LoanDeduction] || 0), 0); const totalSum = sumFieldNames - sumDeductions - sumLoanDeductions; const sumFieldNames_3 = Earnings_3.reduce((total, Earnings_3) => total + parseFloat(formik3.values[Earnings_3] || 0), 0); const sumDeductions_3 = Deductions_3.reduce((total, Deductions_3) => total + parseFloat(formik3.values[Deductions_3] || 0), 0); const totalSum_3 = sumFieldNames_3 - sumDeductions_3; const sumFieldNames_4 = Earnings_4.reduce((total, Earnings_4) => total + parseFloat(formik3.values[Earnings_4] || 0), 0); const sumDeductions_4 = Deductions_4.reduce((total, Deductions_4) => total + parseFloat(formik3.values[Deductions_4] || 0), 0); const totalSum_4 = sumFieldNames_4 - sumDeductions_4;

  const getEmpInfo = (emp_type, emp_id) => {
    setChange(emp_type); setTableEnable(false); setViewEnable(true); let params = { emptype_id: emp_type, emp_id: emp_id }; store.dispatch({ type: "SHOW_SPINNER" });

    HousingService.getEmployeeDetailsById(params).then((res) => {
      const employeeID = res.data[0]?.emp_id;
      setEmployeeID(employeeID);
      const employeeTypeID = res.data[0]?.emp_type;
      setSelectedEmpType(employeeTypeID);
      store.dispatch({ type: "HIDE_SPINNER" });

      formik3.setFieldValue("emp_id", res.data[0].emp_id);

      formik3.setFieldValue("prefix", res.data[0].prefix);
      formik3.setFieldValue("firstname", res.data[0].firstname);
      formik3.setFieldValue("lastname", res.data[0].lastname);
      formik3.setFieldValue("surname", res.data[0].surname);
      formik3.setFieldValue("fathername", res.data[0].fathername);
      formik3.setFieldValue("sex", res.data[0].sex);
      formik3.setFieldValue("emp_type", res.data[0].emp_type);
      formik3.setFieldValue("bank_name", res.data[0].bank_name);
      formik3.setFieldValue("designation", res.data[0].designation);
      formik3.setFieldValue("branch_code", res.data[0].branch_code);
      formik3.setFieldValue("account_no", res.data[0].account_no);
      formik3.setFieldValue("ifsc", res.data[0].ifsc);
      formik3.setFieldValue("basic_pay_earnings", !res.data[0].basic_pay_earnings ? 0 : parseFloat(res.data[0].basic_pay_earnings).toFixed(2)); formik3.setFieldValue("per_pay_earnings", !res.data[0].per_pay_earnings ? 0 : parseFloat(res.data[0].per_pay_earnings).toFixed(2)); formik3.setFieldValue("spl_pay_earnings", !res.data[0].spl_pay_earnings ? 0 : parseFloat(res.data[0].spl_pay_earnings).toFixed(2));
      formik3.setFieldValue("da_earnings", !res.data[0].da_earnings ? 0 : parseFloat(res.data[0].da_earnings).toFixed(2)); formik3.setFieldValue("da_earnings", !res.data[0].da_earnings ? 0 : parseFloat(res.data[0].da_earnings).toFixed(2)); formik3.setFieldValue("hra_earnings", !res.data[0].hra_earnings ? 0 : parseFloat(res.data[0].hra_earnings).toFixed(2)); formik3.setFieldValue("addl_hra", !res.data[0].addl_hra ? 0 : parseFloat(res.data[0].addl_hra).toFixed(2));
      formik3.setFieldValue("cca_earnings", !res.data[0].cca_earnings ? 0 : parseFloat(res.data[0].cca_earnings).toFixed(2)); formik3.setFieldValue("gp_earnings", !res.data[0].gp_earnings ? 0 : parseFloat(res.data[0].gp_earnings).toFixed(2)); formik3.setFieldValue("ir_earnings", !res.data[0].ir_earnings ? 0 : parseFloat(res.data[0].ir_earnings).toFixed(2)); formik3.setFieldValue("ir_earnings", !res.data[0].ir_earnings ? 0 : parseFloat(res.data[0].ir_earnings).toFixed(2)); formik3.setFieldValue("medical_earnings", !res.data[0].medical_earnings ? 0 : parseFloat(res.data[0].medical_earnings).toFixed(2));
      formik3.setFieldValue("ca_earnings", !res.data[0].ca_earnings ? 0 : parseFloat(res.data[0].ca_earnings).toFixed(2)); formik3.setFieldValue("spl_all", !res.data[0].spl_all ? 0 : parseFloat(res.data[0].spl_all).toFixed(2)); formik3.setFieldValue("misc_h_c", !res.data[0].misc_h_c ? 0 : parseFloat(res.data[0].misc_h_c).toFixed(2)); formik3.setFieldValue("addl_hra", !res.data[0].addl_hra ? 0 : parseFloat(res.data[0].addl_hra).toFixed(2)); formik3.setFieldValue("sca", !res.data[0].sca ? 0 : parseFloat(res.data[0].sca).toFixed(2));
      formik3.setFieldValue("gpfs_deductions", !res.data[0].gpfs_deductions ? 0 : parseFloat(res.data[0].gpfs_deductions).toFixed(2)); formik3.setFieldValue("gpfsa_deductions", !res.data[0].gpfsa_deductions ? 0 : parseFloat(parseFloat(res.data[0].gpfsa_deductions)).toFixed(2)); formik3.setFieldValue("gpfl_deductions", !res.data[0].gpfl_deductions ? 0 : parseFloat(res.data[0].gpfl_deductions).toFixed(2)); formik3.setFieldValue("apglis_deductions", !res.data[0].apglis_deductions ? 0 : parseFloat(res.data[0].apglis_deductions).toFixed(2));
      formik3.setFieldValue("apglil_deductions", !res.data[0].apglil_deductions ? 0 : parseFloat(res.data[0].apglil_deductions).toFixed(2)); formik3.setFieldValue("gis_deductions", !res.data[0].gis_deductions ? 0 : parseFloat(res.data[0].gis_deductions).toFixed(2)); formik3.setFieldValue("lic_deductions", !res.data[0].lic_deductions ? 0 : parseFloat(res.data[0].lic_deductions).toFixed(2)); formik3.setFieldValue("license_deductions", !res.data[0].license_deductions ? 0 : parseFloat(res.data[0].license_deductions).toFixed(2)); formik3.setFieldValue("con_decd_deductions", !res.data[0].con_decd_deductions ? 0 : parseFloat(res.data[0].con_decd_deductions).toFixed(2));
      formik3.setFieldValue("epf_deductions", !res.data[0].epf_deductions ? 0 : parseFloat(res.data[0].epf_deductions).toFixed(2)); formik3.setFieldValue("epf_deductions", !res.data[0].epf_deductions ? 0 : parseFloat(res.data[0].epf_deductions).toFixed(2)); formik3.setFieldValue("epf_l_deductions", !res.data[0].epf_l_deductions ? 0 : parseFloat(res.data[0].epf_l_deductions).toFixed(2)); formik3.setFieldValue("vpf_deductions", !res.data[0].vpf_deductions ? 0 : parseFloat(res.data[0].vpf_deductions).toFixed(2));
      formik3.setFieldValue("ppf_deductions", !res.data[0].ppf_deductions ? 0 : parseFloat(res.data[0].ppf_deductions).toFixed(2)); formik3.setFieldValue("rcs_cont_deductions", !res.data[0].rcs_cont_deductions ? 0 : parseFloat(res.data[0].rcs_cont_deductions).toFixed(2)); formik3.setFieldValue("cmrf_deductions", !res.data[0].cmrf_deductions ? 0 : parseFloat(res.data[0].cmrf_deductions).toFixed(2)); formik3.setFieldValue("fcf_deductions", !res.data[0].fcf_deductions ? 0 : parseFloat(res.data[0].fcf_deductions).toFixed(2));
      formik3.setFieldValue("house_rent_deductions", !res.data[0].house_rent_deductions ? 0 : parseFloat(res.data[0].house_rent_deductions).toFixed(2)); formik3.setFieldValue("sal_rec_deductions", !res.data[0].sal_rec_deductions ? 0 : parseFloat(res.data[0].sal_rec_deductions).toFixed(2)); formik3.setFieldValue("pt_deductions", !res.data[0].pt_deductions ? 0 : parseFloat(res.data[0].pt_deductions).toFixed(2)); formik3.setFieldValue("it_deductions", !res.data[0].it_deductions ? 0 : parseFloat(res.data[0].it_deductions).toFixed(2)); formik3.setFieldValue("other_deductions", !res.data[0].other_deductions ? 0 : parseFloat(res.data[0].other_deductions).toFixed(2)); formik3.setFieldValue("car_a_loanpi", !res.data[0].car_a_loanpi ? 0 : parseFloat(res.data[0].car_a_loanpi).toFixed(2)); formik3.setFieldValue("car_a_loanti", !res.data[0].car_a_loanti ? 0 : parseFloat(res.data[0].car_a_loanti).toFixed(2)); formik3.setFieldValue("car_a_loan", !res.data[0].car_a_loan ? 0 : parseFloat(res.data[0].car_a_loan).toFixed(2)); formik3.setFieldValue("car_i_loanpi", !res.data[0].car_i_loanpi ? 0 : parseFloat(res.data[0].car_i_loanpi).toFixed(2)); formik3.setFieldValue("car_i_loanti", !res.data[0].car_i_loanti ? 0 : parseFloat(res.data[0].car_i_loanti).toFixed(2)); formik3.setFieldValue("car_i_loan", !res.data[0].car_i_loan ? 0 : parseFloat(res.data[0].car_i_loan).toFixed(2)); formik3.setFieldValue("cyc_a_loanpi", !res.data[0].cyc_a_loanpi ? 0 : parseFloat(res.data[0].cyc_a_loanpi).toFixed(2));
      formik3.setFieldValue("cyc_a_loanti", !res.data[0].cyc_a_loanti ? 0 : parseFloat(res.data[0].cyc_a_loanti).toFixed(2)); formik3.setFieldValue("cyc_a_loan", !res.data[0].cyc_a_loan ? 0 : parseFloat(res.data[0].cyc_a_loan).toFixed(2)); formik3.setFieldValue("cyc_i_loanpi", !res.data[0].cyc_i_loanpi ? 0 : parseFloat(res.data[0].cyc_i_loanpi).toFixed(2)); formik3.setFieldValue("cyc_i_loanti", !res.data[0].cyc_i_loanti ? 0 : parseFloat(res.data[0].cyc_i_loanti).toFixed(2)); formik3.setFieldValue("cyc_i_loan", !res.data[0].cyc_i_loan ? 0 : parseFloat(res.data[0].cyc_i_loan).toFixed(2)); formik3.setFieldValue("mca_a_loanpi", !res.data[0].mca_a_loanpi ? 0 : parseFloat(res.data[0].mca_a_loanpi).toFixed(2)); formik3.setFieldValue("mca_a_loanti", !res.data[0].mca_a_loanti ? 0 : parseFloat(res.data[0].mca_a_loanti).toFixed(2)); formik3.setFieldValue("mca_a_loan", !res.data[0].mca_a_loan ? 0 : parseFloat(res.data[0].mca_a_loan).toFixed(2)); formik3.setFieldValue("mca_i_loanpi", !res.data[0].mca_i_loanpi ? 0 : parseFloat(res.data[0].mca_i_loanpi).toFixed(2)); formik3.setFieldValue("mca_i_loanti", !res.data[0].mca_i_loanti ? 0 : parseFloat(res.data[0].mca_i_loanti).toFixed(2)); formik3.setFieldValue("mca_i_loan", !res.data[0].mca_i_loan ? 0 : parseFloat(res.data[0].mca_i_loan).toFixed(2));
      formik3.setFieldValue("mar_a_loanpi", !res.data[0].mar_a_loanpi ? 0 : parseFloat(res.data[0].mar_a_loanpi).toFixed(2)); formik3.setFieldValue("mar_a_loanti", !res.data[0].mar_a_loanti ? 0 : parseFloat(res.data[0].mar_a_loanti).toFixed(2)); formik3.setFieldValue("mar_a_loan", !res.data[0].mar_a_loan ? 0 : parseFloat(res.data[0].mar_a_loan).toFixed(2)); formik3.setFieldValue("mar_i_loanpi", !res.data[0].mar_i_loanpi ? 0 : parseFloat(res.data[0].mar_i_loanpi).toFixed(2)); formik3.setFieldValue("mar_i_loanti", !res.data[0].mar_i_loanti ? 0 : parseFloat(res.data[0].mar_i_loanti).toFixed(2)); formik3.setFieldValue("mar_i_loan", !res.data[0].mar_i_loan ? 0 : parseFloat(res.data[0].mar_i_loan).toFixed(2));
      formik3.setFieldValue("med_a_loanpi", !res.data[0].med_a_loanpi ? 0 : parseFloat(res.data[0].med_a_loanpi).toFixed(2)); formik3.setFieldValue("med_a_loanti", !res.data[0].med_a_loanti ? 0 : parseFloat(res.data[0].med_a_loanti).toFixed(2)); formik3.setFieldValue("med_a_loan", !res.data[0].med_a_loan ? 0 : parseFloat(res.data[0].med_a_loan).toFixed(2)); formik3.setFieldValue("med_a_i_loanpi", !res.data[0].med_a_i_loanpi ? 0 : parseFloat(res.data[0].med_a_i_loanpi).toFixed(2));
      formik3.setFieldValue("med_a_i_loanti", !res.data[0].med_a_i_loanti ? 0 : parseFloat(res.data[0].med_a_i_loanti).toFixed(2)); formik3.setFieldValue("med_a_i_loan", !res.data[0].med_a_i_loan ? 0 : parseFloat(res.data[0].med_a_i_loan).toFixed(2)); formik3.setFieldValue("hba_loanpi", !res.data[0].hba_loanpi ? 0 : parseFloat(res.data[0].hba_loanpi).toFixed(2));
      formik3.setFieldValue("hba_loanti", !res.data[0].hba_loanti ? 0 : parseFloat(res.data[0].hba_loanti).toFixed(2)); formik3.setFieldValue("hba_loan", !res.data[0].hba_loan ? 0 : parseFloat(res.data[0].hba_loan).toFixed(2)); formik3.setFieldValue("hba1_loanpi", !res.data[0].hba1_loanpi ? 0 : parseFloat(res.data[0].hba1_loanpi).toFixed(2)); formik3.setFieldValue("hba1_loanti", !res.data[0].hba1_loanti ? 0 : parseFloat(res.data[0].hba1_loanti).toFixed(2)); formik3.setFieldValue("hba1_loan", !res.data[0].hba1_loan ? 0 : parseFloat(res.data[0].hba1_loan).toFixed(2)); formik3.setFieldValue("add_hba_loanpi", !res.data[0].add_hba_loanpi ? 0 : parseFloat(res.data[0].add_hba_loanpi).toFixed(2)); formik3.setFieldValue("add_hba_loanti", !res.data[0].add_hba_loanti ? 0 : parseFloat(res.data[0].add_hba_loanti).toFixed(2)); formik3.setFieldValue("add_hba_loan", !res.data[0].add_hba_loan ? 0 : parseFloat(res.data[0].add_hba_loan).toFixed(2)); formik3.setFieldValue("add_hba1_loanpi", !res.data[0].add_hba1_loanpi ? 0 : parseFloat(res.data[0].add_hba1_loanpi).toFixed(2));
      formik3.setFieldValue("add_hba1_loanti", !res.data[0].add_hba1_loanti ? 0 : parseFloat(res.data[0].add_hba1_loanti).toFixed(2)); formik3.setFieldValue("add_hba1_loan", !res.data[0].add_hba1_loan ? 0 : parseFloat(res.data[0].add_hba1_loan).toFixed(2)); formik3.setFieldValue("comp_loanpi", !res.data[0].comp_loanpi ? 0 : parseFloat(res.data[0].comp_loanpi).toFixed(2)); formik3.setFieldValue("comp_loanti", !res.data[0].comp_loanti ? 0 : parseFloat(res.data[0].comp_loanti).toFixed(2));
      formik3.setFieldValue("comp_loan", !res.data[0].comp_loan ? 0 : parseFloat(res.data[0].comp_loan).toFixed(2)); formik3.setFieldValue("comp1_loanpi", !res.data[0].comp1_loanpi ? 0 : parseFloat(res.data[0].comp1_loanpi).toFixed(2)); formik3.setFieldValue("comp1_loanti", !res.data[0].comp1_loanti ? 0 : parseFloat(res.data[0].comp1_loanti).toFixed(2)); formik3.setFieldValue("comp1_loan", !res.data[0].comp1_loan ? 0 : parseFloat(res.data[0].comp1_loan).toFixed(2)); formik3.setFieldValue("hcesa_loanpi", !res.data[0].hcesa_loanpi ? 0 : parseFloat(res.data[0].hcesa_loanpi).toFixed(2)); formik3.setFieldValue("hcesa_loanti", !res.data[0].hcesa_loanti ? 0 : parseFloat(res.data[0].hcesa_loanti).toFixed(2)); formik3.setFieldValue("hcesa_loan", !res.data[0].hcesa_loan ? 0 : parseFloat(res.data[0].hcesa_loan).toFixed(2)); formik3.setFieldValue("hcesa_i_loanpi", !res.data[0].hcesa_i_loanpi ? 0 : parseFloat(res.data[0].hcesa_i_loanpi).toFixed(2)); formik3.setFieldValue("hcesa_i_loanti", !res.data[0].hcesa_i_loanti ? 0 : parseFloat(res.data[0].hcesa_i_loanti).toFixed(2)); formik3.setFieldValue("hcesa_i_loan", !res.data[0].hcesa_i_loan ? 0 : parseFloat(res.data[0].hcesa_i_loan).toFixed(2)); formik3.setFieldValue("hbao_loanpi", !res.data[0].hbao_loanpi ? 0 : parseFloat(res.data[0].hbao_loanpi).toFixed(2)); formik3.setFieldValue("hbao_loanti", !res.data[0].hbao_loanti ? 0 : parseFloat(res.data[0].hbao_loanti).toFixed(2));
      formik3.setFieldValue("hbao_loan", !res.data[0].hbao_loan ? 0 : parseFloat(res.data[0].hbao_loan).toFixed(2));
      formik3.setFieldValue("vij_bank_loanpi", !res.data[0].vij_bank_loanpi ? 0 : parseFloat(res.data[0].vij_bank_loanpi).toFixed(2)); formik3.setFieldValue("vij_bank_loanti", !res.data[0].vij_bank_loanti ? 0 : parseFloat(res.data[0].vij_bank_loanti).toFixed(2)); formik3.setFieldValue("vij_bank_loan", !res.data[0].vij_bank_loan ? 0 : parseFloat(res.data[0].vij_bank_loan).toFixed(2)); formik3.setFieldValue("fa_loanpi", !res.data[0].fa_loanpi ? 0 : parseFloat(res.data[0].fa_loanpi).toFixed(2)); formik3.setFieldValue("fa_loanti", !res.data[0].fa_loanti ? 0 : parseFloat(res.data[0].fa_loanti).toFixed(2)); formik3.setFieldValue("fa_loan", !res.data[0].fa_loan ? 0 : parseFloat(res.data[0].fa_loan).toFixed(2)); formik3.setFieldValue("ea_loanpi", !res.data[0].ea_loanpi ? 0 : parseFloat(res.data[0].ea_loanpi).toFixed(2));
      formik3.setFieldValue("ea_loanti", !res.data[0].ea_loanti ? 0 : parseFloat(res.data[0].ea_loanti).toFixed(2)); formik3.setFieldValue("ea_loan", !res.data[0].ea_loan ? 0 : parseFloat(res.data[0].ea_loan).toFixed(2)); formik3.setFieldValue("sfa_loanpi", !res.data[0].sfa_loanpi ? 0 : parseFloat(res.data[0].sfa_loanpi).toFixed(2)); formik3.setFieldValue("sfa_loanti", !res.data[0].sfa_loanti ? 0 : parseFloat(res.data[0].sfa_loanti).toFixed(2));
      formik3.setFieldValue("sfa_loan ", !res.data[0].sfa_loan ? 0 : parseFloat(res.data[0].sfa_loan).toFixed(2)); formik3.setFieldValue("sal_adv_loanpi", !res.data[0].sal_adv_loanpi ? 0 : parseFloat(res.data[0].sal_adv_loanpi).toFixed(2)); formik3.setFieldValue("sal_adv_loanti", !res.data[0].sal_adv_loanti ? 0 : parseFloat(res.data[0].sal_adv_loanti).toFixed(2)); formik3.setFieldValue("sal_adv_loan", !res.data[0].sal_adv_loan ? 0 : parseFloat(res.data[0].sal_adv_loan).toFixed(2)); formik3.setFieldValue("hr_arrear_loanpi", !res.data[0].hr_arrear_loanpi ? 0 : parseFloat(res.data[0].hr_arrear_loanpi).toFixed(2));
      formik3.setFieldValue("hr_arrear_loanti", !res.data[0].hr_arrear_loanti ? 0 : parseFloat(res.data[0].hr_arrear_loanti).toFixed(2)); formik3.setFieldValue("hr_arrear_loan", !res.data[0].hr_arrear_loan ? 0 : parseFloat(res.data[0].hr_arrear_loan).toFixed(2)); formik3.setFieldValue("cell_loanpi", !res.data[0].cell_loanpi ? 0 : parseFloat(res.data[0].cell_loanpi).toFixed(2)); formik3.setFieldValue("cell_loanti", !res.data[0].cell_loanti ? 0 : parseFloat(res.data[0].cell_loanti).toFixed(2)); formik3.setFieldValue("cell_loan", !res.data[0].cell_loan ? 0 : parseFloat(res.data[0].cell_loan).toFixed(2)); formik3.setFieldValue("staff_pl_loanpi", !res.data[0].staff_pl_loanpi ? 0 : parseFloat(res.data[0].staff_pl_loanpi).toFixed(2)); formik3.setFieldValue("staff_pl_loanti", !res.data[0].staff_pl_loanti ? 0 : parseFloat(res.data[0].staff_pl_loanti).toFixed(2)); formik3.setFieldValue("staff_pl_loan", !res.data[0].staff_pl_loan ? 0 : parseFloat(res.data[0].staff_pl_loan).toFixed(2)); formik3.setFieldValue("court_loanpi", !res.data[0].court_loanpi ? 0 : parseFloat(res.data[0].court_loanpi).toFixed(2)); formik3.setFieldValue("court_loanti", !res.data[0].court_loanti ? 0 : parseFloat(res.data[0].court_loanti).toFixed(2)); formik3.setFieldValue("court_loan", !res.data[0].court_loan ? 0 : parseFloat(res.data[0].court_loan).toFixed(2));
      formik3.setFieldValue("os_location", res.data[0].os_location);
      formik3.setFieldValue("os_work_place", res.data[0].os_work_place);
      formik3.setFieldValue("os_basic_pay_earnings", !res.data[0].os_basic_pay_earnings ? 0 : parseFloat(res.data[0].os_basic_pay_earnings).toFixed(2)); formik3.setFieldValue("os_hra_earnings", !res.data[0].os_hra_earnings ? 0 : parseFloat(res.data[0].os_hra_earnings).toFixed(2)); formik3.setFieldValue("os_medical_earnings", !res.data[0].os_medical_earnings ? 0 : parseFloat(res.data[0].os_medical_earnings).toFixed(2)); formik3.setFieldValue("os_ca_earnings", !res.data[0].os_ca_earnings ? 0 : parseFloat(res.data[0].os_ca_earnings).toFixed(2)); formik3.setFieldValue("os_performance_earnings", !res.data[0].os_performance_earnings ? 0 : parseFloat(res.data[0].os_performance_earnings).toFixed(2)); formik3.setFieldValue("os_ec_epf", !res.data[0].os_ec_epf ? 0 : parseFloat(res.data[0].os_ec_epf).toFixed(2)); formik3.setFieldValue("os_prof_tax_deductions", !res.data[0].os_prof_tax_deductions ? 0 : parseFloat(res.data[0].os_prof_tax_deductions).toFixed(2));
      formik3.setFieldValue("os_ees_epf_deductions", !res.data[0].os_ees_epf_deductions ? 0 : parseFloat(res.data[0].os_ees_epf_deductions).toFixed(2)); formik3.setFieldValue("os_ers_epf_deductions", !res.data[0].os_ers_epf_deductions ? 0 : parseFloat(res.data[0].os_ers_epf_deductions).toFixed(2)); formik3.setFieldValue("os_other_deductions", !res.data[0].os_other_deductions ? 0 : parseFloat(res.data[0].os_other_deductions).toFixed(2)); formik3.setFieldValue("os_prof_tax_deductions", !res.data[0].os_prof_tax_deductions ? 0 : parseFloat(res.data[0].os_prof_tax_deductions).toFixed(2)); formik3.setFieldValue("nmr_gross_earnings", !res.data[0]?.nmr_gross_earnings ? 0 : parseFloat(res.data[0]?.nmr_gross_earnings).toFixed(2)); formik3.setFieldValue("nmr_tds_deductions", !res.data[0].nmr_tds_deductions ? 0 : parseFloat(res.data[0].nmr_tds_deductions).toFixed(2)); formik3.setFieldValue("nmr_fa_deductions", !res.data[0].nmr_fa_deductions ? 0 : parseFloat(res.data[0].nmr_fa_deductions).toFixed(2));
      formik3.setFieldValue("nmr_ea_deductions", !res.data[0].nmr_ea_deductions ? 0 : parseFloat(res.data[0].nmr_ea_deductions).toFixed(2)); formik3.setFieldValue("nmr_ma_deductions", !res.data[0].nmr_ma_deductions ? 0 : parseFloat(res.data[0].nmr_ma_deductions).toFixed(2)); formik3.setFieldValue("nmr_lic_deductions", !res.data[0].nmr_lic_deductions ? 0 : parseFloat(res.data[0].nmr_lic_deductions).toFixed(2));
      formik3.setFieldValue("nmr_otherliab_deductions", !res.data[0].nmr_otherliab_deductions ? 0 : parseFloat(res.data[0].nmr_otherliab_deductions).toFixed(2)); formik3.setFieldValue("nmr_postalrd_deductions", !res.data[0].nmr_postalrd_deductions ? 0 : parseFloat(res.data[0].nmr_postalrd_deductions).toFixed(2)); formik3.setFieldValue("nmr_tax_deductions", !res.data[0].nmr_tax_deductions ? 0 : parseFloat(res.data[0].nmr_tax_deductions).toFixed(2)); formik3.setFieldValue("nmr_tds_deductions", !res.data[0].nmr_tds_deductions ? 0 : parseFloat(res.data[0].nmr_tds_deductions).toFixed(2));
    });
  };

  const handleRadioChange = (e, id, workingStatus) => {
    const updatedList = selectedList.map((item) => {
      if (item.emp_id === id) {
        return { emp_id: id, working_status: e.target.value };
      }
      return item;
    });

    setSelectedList(updatedList);

    setChangedValues((prevValues) => ({
      ...prevValues,
      [id]: { emp_id: id, working_status: e.target.value }
    }));
  };

  React.useEffect(() => {
    let user = localStorage.getItem("username")
    console.log(user)
    setSaveUser(user)
    HousingService.CGG_District().then((res) => {
      if (res.data) {
        setDistData(res.data);
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.code}>
              {item.name}
            </option>
          );
        });
        setDistList(options);
      }
    });

    HousingService.getCadreWiseDesignationDropdownlist().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => { if (item !== null) { return (<option key={i} value={item.designation_id}> {item.designation_name} </option>); } }); setprdesignationlist(options);
      }
    });
    HousingService.fetchBankName().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => { if (item !== null) { return (<option key={i} value={item.bankid}> {item.bankfullname} </option>); } }); setbankNamesList(options);
      }
    });
    HousingService.fetchEmptypeList().then((res) => {
      if (res.data) { let options = res.data.map((item, i) => { return (<option key={i} value={item.emptype_id}> {item.emptype_name} </option>); }); setEmpTypeList(options); }
    });
  }, []);

  const backing = () => { setTableEnable(true); setViewEnable(false); setSelectedEmpType(""); };
  const updateWorkStatus = () => {
    let changedRecords = Object.values(changedValues);
    let params = {
      employeeStatusList: changedRecords
    };
    Swal.fire({
      text: "Are You Sure Want to Update?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes"
    }).then((result) => {
      if (result.isConfirmed) {
        HousingService.ConfirmEmp_WorkStatus_Report(params).then((res) => {
          if (res.data.SCODE === "01") {
            showNotification("success", "Updated successfully"); let params = { district: formik3.values.district, emptype_id: formik3.values.emptype_id };
            store.dispatch({ type: "SHOW_SPINNER" });

            HousingService.ConfirmEmp_OnRolls_Report(params).then((res) => { settabledata(res.data); setSelectedList(res.data.map((item) => ({ emp_id: item.emp_id, working_status: item.working_status }))); });

            setTableEnable(true);
            setViewEnable(false);
            setSelectedEmpType("");
            store.dispatch({ type: "HIDE_SPINNER" });
          }
        });
      }
    });
  };

  const ConfirmEmpUpdateReport = () => {
    let param1 = {
      emp_id: employeeID,
      prefix: formik3.values.prefix,
      firstname: formik3.values.firstname,
      lastname: formik3.values.lastname,
      surname: formik3.values.surname,
      fathername: formik3.values.fathername,
      emptype_id: formik3.values.emptype_id,
      sex: formik3.values.sex,
      designation: formik3.values.designation,
      account_no: formik3.values.account_no,
      others: formik3.values.others,
      bank_name: formik3.values.bank_name,
      branch_code: formik3.values.branch_code,
      ifsc: formik3.values.ifsc,

      basic_pay_earnings: formik3.values.basic_pay_earnings,
      per_pay_earnings: formik3.values.per_pay_earnings,
      spl_pay_earnings: formik3.values.spl_pay_earnings,
      da_earnings: formik3.values.da_earnings,
      hra_earnings: formik3.values.hra_earnings,
      cca_earnings: formik3.values.cca_earnings,
      gp_earnings: formik3.values.gp_earnings,
      ir_earnings: formik3.values.ir_earnings,
      medical_earnings: formik3.values.medical_earnings,
      ca_earnings: formik3.values.ca_earnings,
      spl_all: formik3.values.spl_all,
      misc_h_c: formik3.values.misc_h_c,
      addl_hra: formik3.values.addl_hra,
      sca: formik3.values.sca,


      gpfs_deductions: formik3.values.gpfs_deductions,
      gpfl_deductions: formik3.values.gpfl_deductions,
      gpfsa_deductions: formik3.values.gpfsa_deductions,
      house_rent_deductions: formik3.values.house_rent_deductions,
      gis_deductions: formik3.values.gis_deductions,
      pt_deductions: formik3.values.pt_deductions,
      it_deductions: formik3.values.it_deductions,
      cca_deductions: formik3.values.cca_deductions,
      license_deductions: formik3.values.license_deductions,
      con_decd_deductions: formik3.values.con_decd_deductions,
      lic_deductions: formik3.values.lic_deductions,
      rcs_cont_deductions: formik3.values.rcs_cont_deductions,
      sal_rec_deductions: formik3.values.sal_rec_deductions,
      cmrf_deductions: formik3.values.cmrf_deductions,
      fcf_deductions: formik3.values.fcf_deductions,
      epf_l_deductions: formik3.values.epf_l_deductions,
      vpf_deductions: formik3.values.vpf_deductions,
      apglis_deductions: formik3.values.apglis_deductions,
      apglil_deductions: formik3.values.apglil_deductions,
      epf_deductions: formik3.values.epf_deductions,
      ppf_deductions: formik3.values.ppf_deductions,
      other_deductions: formik3.values.other_deductions,

      car_a_loan: formik3.values.car_a_loan,
      car_a_loanpi: formik3.values.car_a_loanpi,
      car_a_loanti: formik3.values.car_a_loanti,

      car_i_loanpi: formik3.values.car_i_loanpi,
      car_i_loanti: formik3.values.car_i_loanti,
      car_i_loan: formik3.values.car_i_loan,

      cyc_i_loanpi: formik3.values.cyc_i_loanpi,
      cyc_i_loanti: formik3.values.cyc_i_loanti,
      cyc_i_loan: formik3.values.cyc_i_loan,

      cyc_a_loanpi: formik3.values.cyc_a_loanpi,
      cyc_a_loanti: formik3.values.cyc_a_loanti,
      cyc_a_loan: formik3.values.cyc_a_loan,

      mca_i_loanpi: formik3.values.mca_i_loanpi,
      mca_i_loanti: formik3.values.mca_i_loanti,
      mca_i_loan: formik3.values.mca_i_loan,

      mca_a_loanpi: formik3.values.mca_a_loanpi,
      mca_a_loanti: formik3.values.mca_a_loanti,
      mca_a_loan: formik3.values.mca_a_loan,

      mar_a_loanpi: formik3.values.mar_a_loanpi,
      mar_a_loanti: formik3.values.mar_a_loanti,
      mar_a_loan: formik3.values.mar_a_loan,

      mar_i_loanpi: formik3.values.mar_i_loanpi,
      mar_i_loanti: formik3.values.mar_i_loanti,
      mar_i_loan: formik3.values.mar_i_loan,

      med_a_loanpi: formik3.values.med_a_loanpi,
      med_a_loanti: formik3.values.med_a_loanti,
      med_a_loan: formik3.values.med_a_loan,

      med_a_i_loanpi: formik3.values.med_a_i_loanpi,
      med_a_i_loanti: formik3.values.med_a_i_loanti,
      med_a_i_loan: formik3.values.med_a_i_loan,

      hba_loanpi: formik3.values.hba_loanpi,
      hba_loanti: formik3.values.hba_loanti,
      hba_loan: formik3.values.hba_loan,

      hba1_loanpi: formik3.values.hba1_loanpi,
      hba1_loanti: formik3.values.hba1_loanti,
      hba1_loan: formik3.values.hba1_loan,

      add_hba_loanpi: formik3.values.add_hba_loanpi,
      add_hba_loanti: formik3.values.add_hba_loanti,
      add_hba1_loan: formik3.values.add_hba1_loan,

      comp_loanpi: formik3.values.comp_loanpi,
      comp_loanti: formik3.values.comp_loanti,
      comp_loan: formik3.values.comp_loan,

      comp1_loanpi: formik3.values.comp1_loanpi,
      comp1_loanti: formik3.values.comp1_loanti,
      comp1_loan: formik3.values.comp1_loan,

      hcesa_loanpi: formik3.values.hcesa_loanpi,
      hcesa_loanti: formik3.values.hcesa_loanti,
      hcesa_loan: formik3.values.hcesa_loan,

      hcesa_i_loanpi: formik3.values.hcesa_i_loanpi,
      hcesa_i_loanti: formik3.values.hcesa_i_loanti,
      hcesa_i_loan: formik3.values.hcesa_i_loan,

      hbao_loanpi: formik3.values.hbao_loanpi,
      hbao_loanti: formik3.values.hbao_loanti,
      hbao_loan: formik3.values.hbao_loan,

      vij_bank_loanpi: formik3.values.vij_bank_loanpi,
      vij_bank_loanti: formik3.values.vij_bank_loanti,
      vij_bank_loan: formik3.values.vij_bank_loan,

      fa_loanpi: formik3.values.fa_loanpi,
      fa_loanti: formik3.values.fa_loanti,
      fa_loan: formik3.values.fa_loan,

      ea_loanpi: formik3.values.ea_loanpi,
      ea_loanti: formik3.values.ea_loanti,
      ea_loan: formik3.values.ea_loan,

      sal_adv_loanpi: formik3.values.sal_adv_loanpi,
      sal_adv_loanti: formik3.values.sal_adv_loanti,
      sal_adv_loan: formik3.values.sal_adv_loan,

      hr_arrear_loanpi: formik3.values.hr_arrear_loanpi,
      hr_arrear_loanti: formik3.values.hr_arrear_loanti,
      hr_arrear_loan: formik3.values.hr_arrear_loan,

      cell_loanpi: formik3.values.cell_loanpi,
      cell_loanti: formik3.values.cell_loanti,
      cell_loan: formik3.values.cell_loan,

      staff_pl_loanpi: formik3.values.staff_pl_loanpi,
      staff_pl_loanti: formik3.values.staff_pl_loanti,
      staff_pl_loan: formik3.values.staff_pl_loan,

      court_loanpi: formik3.values.court_loanpi,
      court_loanti: formik3.values.court_loanti,
      court_loan: formik3.values.court_loan,

      sfa_loanpi: formik3.values.sfa_loanpi,
      sfa_loanti: formik3.values.sfa_loanti,
      sfa_loan: formik3.values.sfa_loan,

      add_hba_loan: formik3.values.add_hba_loan,
      add_hba1_loanpi: formik3.values.add_hba1_loanpi,
      add_hba1_loanti: formik3.values.add_hba1_loanti,

    };
    Swal.fire({ text: "Are You Sure Want to Update?", icon: "question", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes" }).then((result) => {
      if (result.isConfirmed) {
        HousingService.updateEmployeeDetailsType125(param1).then((res) => {
          if (res.data.SCODE === "01") { ShowAlert(res.data.SDESC, "success").then(function (isConfirm) { if (isConfirm.value) { history.go(0); } }); }
        });
      }
    });
  };
  const ConfirmEmpUpdateReport3 = () => {
    let param3 = {
      emp_id: employeeID,
      prefix: formik3.values.prefix,
      firstname: formik3.values.firstname,
      lastname: formik3.values.lastname,
      surname: formik3.values.surname,
      fathername: formik3.values.fathername,
      emptype_id: selectedEmpType,
      sex: formik3.values.sex,
      designation: formik3.values.designation,
      account_no: formik3.values.account_no,
      others: formik3.values.others,
      bank_name: formik3.values.bank_name,
      branch_code: formik3.values.branch_code,
      ifsc: formik3.values.ifsc,

      os_work_place: formik3.values.os_work_place,
      os_location: formik3.values.os_location,

      os_basic_pay_earnings: formik3.values.os_basic_pay_earnings,
      os_hra_earnings: formik3.values.os_hra_earnings,
      os_medical_earnings: formik3.values.os_medical_earnings,

      os_ca_earnings: formik3.values.os_ca_earnings,
      os_performance_earnings: formik3.values.os_performance_earnings,
      os_ec_epf: formik3.values.os_ec_epf,

      os_prof_tax_deductions: formik3.values.os_prof_tax_deductions,
      os_ees_epf_deductions: formik3.values.os_ees_epf_deductions,
      os_ers_epf_deductions: formik3.values.os_ers_epf_deductions,

      os_other_deductions: formik3.values.os_other_deductions
    };
    Swal.fire({ text: "Are You Sure Want to Update?", icon: "question", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes" }).then((result) => {
      if (result.isConfirmed) {
        HousingService.updateEmployeeDetailsType3(param3).then((res) => {
          if (res.data.SCODE === "01") { ShowAlert(res.data.SDESC, "success").then(function (isConfirm) { if (isConfirm.value) { history.go(0); } }); }
        });
      }
    });
  };
  const ConfirmEmpUpdateReport4 = () => {
    console.log("employee type 4")
    let param4 = {
      emp_id: employeeID,
      prefix: formik3.values.prefix,
      firstname: formik3.values.firstname,
      lastname: formik3.values.lastname,
      surname: formik3.values.surname,
      fathername: formik3.values.fathername,
      emptype_id: selectedEmpType,
      sex: formik3.values.sex,
      designation: formik3.values.designation,
      account_no: formik3.values.account_no,
      bank_name: formik3.values.bank_name,
      branch_code: formik3.values.branch_code,

      ifsc: formik3.values.ifsc,
      os_work_place: formik3.values.os_work_place,
      os_location: formik3.values.os_location,

      //================> type 4<=====================================

      nmr_gross_earnings: formik3.values.nmr_gross_earnings,
      nmr_postalrd_deductions: formik3.values.nmr_postalrd_deductions,

      nmr_tds_deductions: formik3.values.nmr_tds_deductions,
      nmr_fa_deductions: formik3.values.nmr_fa_deductions,
      nmr_ea_deductions: formik3.values.nmr_ea_deductions,

      nmr_ma_deductions: formik3.values.nmr_ma_deductions,
      nmr_lic_deductions: formik3.values.nmr_lic_deductions,
      nmr_otherliab_deductions: formik3.values.nmr_otherliab_deductions,
      os_prof_tax_deductions: formik3.values.os_prof_tax_deductions
    };
    Swal.fire({ text: "Are You Sure Want to Update?", icon: "question", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes" }).then((result) => {
      if (result.isConfirmed) {
        HousingService.updateEmployeeDetailsType4(param4)
          .then((res) => {
            if (res.data.SCODE === "01") { ShowAlert(res.data.SDESC, "success").then(function (isConfirm) { if (isConfirm.value) { history.go(0); } }); }
          }).catch((error) => { ShowAlert(error.message, "error"); });
      }
    });
  };
  const updateEmployeeDetailsToReg = () => {
    let param1 = {
      dist_code: formik3.values.district, emp_id: employeeID, prefix: formik3.values.prefix, firstname: formik3.values.firstname, lastname: formik3.values.lastname, surname: formik3.values.surname, fathername: formik3.values.fathername, emptype_id: formik3.values.emp_type, sex: formik3.values.sex, designation: formik3.values.designation, account_no: formik3.values.account_no, others: formik3.values.others, bank_name: formik3.values.bank_name, branch_code: formik3.values.branch_code, ifsc: formik3.values.ifsc,

      basic_pay_earnings: formik3.values.basic_pay_earnings, per_pay_earnings: formik3.values.per_pay_earnings, spl_pay_earnings: formik3.values.spl_pay_earnings, da_earnings: formik3.values.da_earnings, hra_earnings: formik3.values.hra_earnings, cca_earnings: formik3.values.cca_earnings, gp_earnings: formik3.values.gp_earnings, ir_earnings: formik3.values.ir_earnings, medical_earnings: formik3.values.medical_earnings, ca_earnings: formik3.values.ca_earnings, spl_all: formik3.values.spl_all, misc_h_c: formik3.values.misc_h_c, addl_hra: formik3.values.addl_hra, sca: formik3.values.sca,

      gpfs_deductions: formik3.values.gpfs_deductions, gpfl_deductions: formik3.values.gpfl_deductions, gpfsa_deductions: formik3.values.gpfsa_deductions, house_rent_deductions: formik3.values.house_rent_deductions, gis_deductions: formik3.values.gis_deductions, pt_deductions: formik3.values.pt_deductions, it_deductions: formik3.values.it_deductions, cca_deductions: formik3.values.cca_deductions, license_deductions: formik3.values.license_deductions, con_decd_deductions: formik3.values.con_decd_deductions, lic_deductions: formik3.values.lic_deductions, rcs_cont_deductions: formik3.values.rcs_cont_deductions, sal_rec_deductions: formik3.values.sal_rec_deductions, cmrf_deductions: formik3.values.cmrf_deductions, fcf_deductions: formik3.values.fcf_deductions, epf_l_deductions: formik3.values.epf_l_deductions, vpf_deductions: formik3.values.vpf_deductions, apglis_deductions: formik3.values.apglis_deductions, apglil_deductions: formik3.values.apglil_deductions, epf_deductions: formik3.values.epf_deductions, ppf_deductions: formik3.values.ppf_deductions, other_deductions: formik3.values.other_deductions,

      car_a_loanti: formik3.values.car_a_loanti,
      add_hba_loan: formik3.values.add_hba_loan,
      add_hba1_loanpi: formik3.values.add_hba1_loanpi,
      add_hba1_loanti: formik3.values.add_hba1_loanti,

      car_a_loan: formik3.values.car_a_loan, car_a_loanpi: formik3.values.car_a_loanpi, cyc_a_loanti: formik3.values.cyc_a_loanti, car_i_loanpi: formik3.values.car_i_loanpi, car_i_loanti: formik3.values.car_i_loanti, car_i_loan: formik3.values.car_i_loan, cyc_i_loanpi: formik3.values.cyc_i_loanpi, cyc_i_loanti: formik3.values.cyc_i_loanti, cyc_i_loan: formik3.values.cyc_i_loan, cyc_a_loanpi: formik3.values.cyc_a_loanpi, cyc_a_loan: formik3.values.cyc_a_loan, mca_i_loanpi: formik3.values.mca_i_loanpi, mca_i_loanti: formik3.values.mca_i_loanti, mca_i_loan: formik3.values.mca_i_loan, mca_a_loanpi: formik3.values.mca_a_loanpi, mca_a_loanti: formik3.values.mca_a_loanti, mca_a_loan: formik3.values.mca_a_loan, mar_a_loanpi: formik3.values.mar_a_loanpi, mar_a_loanti: formik3.values.mar_a_loanti, mar_a_loan: formik3.values.mar_a_loan, mar_i_loanpi: formik3.values.mar_i_loanpi, mar_i_loanti: formik3.values.mar_i_loanti, mar_i_loan: formik3.values.mar_i_loan, med_a_loanpi: formik3.values.med_a_loanpi, med_a_loanti: formik3.values.med_a_loanti, med_a_loan: formik3.values.med_a_loan, med_a_i_loanpi: formik3.values.med_a_i_loanpi, med_a_i_loanti: formik3.values.med_a_i_loanti, med_a_i_loan: formik3.values.med_a_i_loan,

      hba_loanpi: formik3.values.hba_loanpi, hba_loanti: formik3.values.hba_loanti, hba_loan: formik3.values.hba_loan, hba1_loanpi: formik3.values.hba1_loanpi, hba1_loanti: formik3.values.hba1_loanti, hba1_loan: formik3.values.hba1_loan, add_hba_loanpi: formik3.values.add_hba_loanpi, add_hba_loanti: formik3.values.add_hba_loanti, add_hba1_loan: formik3.values.add_hba1_loan, comp_loanpi: formik3.values.comp_loanpi, comp_loanti: formik3.values.comp_loanti, comp_loan: formik3.values.comp_loan, comp1_loanpi: formik3.values.comp1_loanpi, comp1_loanti: formik3.values.comp1_loanti, comp1_loan: formik3.values.comp1_loan, hcesa_loanpi: formik3.values.hcesa_loanpi, hcesa_loanti: formik3.values.hcesa_loanti, hcesa_loan: formik3.values.hcesa_loan, hcesa_i_loanpi: formik3.values.hcesa_i_loanpi, hcesa_i_loanti: formik3.values.hcesa_i_loanti, hcesa_i_loan: formik3.values.hcesa_i_loan, hbao_loanpi: formik3.values.hbao_loanpi, hbao_loanti: formik3.values.hbao_loanti, hbao_loan: formik3.values.hbao_loan,
      vij_bank_loanpi: formik3.values.vij_bank_loanpi, vij_bank_loanti: formik3.values.vij_bank_loanti, vij_bank_loan: formik3.values.vij_bank_loan, fa_loanpi: formik3.values.fa_loanpi, fa_loanti: formik3.values.fa_loanti, fa_loan: formik3.values.fa_loan, ea_loanpi: formik3.values.ea_loanpi, ea_loanti: formik3.values.ea_loanti, ea_loan: formik3.values.ea_loan, sal_adv_loanpi: formik3.values.sal_adv_loanpi, sal_adv_loanti: formik3.values.sal_adv_loanti, sal_adv_loan: formik3.values.sal_adv_loan, hr_arrear_loanpi: formik3.values.hr_arrear_loanpi, hr_arrear_loanti: formik3.values.hr_arrear_loanti, hr_arrear_loan: formik3.values.hr_arrear_loan, cell_loanpi: formik3.values.cell_loanpi, cell_loanti: formik3.values.cell_loanti, cell_loan: formik3.values.cell_loan, staff_pl_loanpi: formik3.values.staff_pl_loanpi, staff_pl_loanti: formik3.values.staff_pl_loanti, staff_pl_loan: formik3.values.staff_pl_loan, court_loanpi: formik3.values.court_loanpi, court_loanti: formik3.values.court_loanti, court_loan: formik3.values.court_loan, sfa_loanpi: formik3.values.sfa_loanpi, sfa_loanti: formik3.values.sfa_loanti, sfa_loan: formik3.values.sfa_loan
    };
    Swal.fire({ text: "Are You Sure Want to Update?", icon: "question", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes" }).then((result) => {
      if (result.isConfirmed) {
        HousingService.updateEmployeeDetailsToReg(param1).then((res) => {
          if (res.data.SCODE === "01") {
            ShowAlert(res.data.SDESC, "success").then(function (isConfirm) { if (isConfirm.value) { history.go(0); } });
          }
        });
      }
    });
  };
  function generatepdf() {
    const pageWidth = 210; // Example: 210mm for A4 size
    const pageHeight = 297; // Example: 297mm for A4 size
    const imgPath = "/img/APSHCL_logo.png";
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [pageWidth, pageHeight]
    });
    const emptype_id = formik3.values.emptype_id; // Get the selected From Date from Formik values
    const distuser = localStorage.getItem("username");
    const districtname = displaydist;

    const headingText2 =
      "Andhra Pradesh State Housing Corporation Limited (APSHCL)"; // New heading text (displayed first)
    const headingText3 = `Confirmation Of Employee On Rolls Report of ${districtname} User: ${distuser} `; // New heading text (displayed second)
    const headingText4 =
      "Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007";

    const fontSize = 12; // Reduce font size to 10 points

    const textWidth4 =
      (doc.getStringUnitWidth(headingText4) * fontSize) /
      doc.internal.scaleFactor;
    const xCoordinate4 = (pageWidth * 1.5 - textWidth4) / 2;

    doc.setFont("times new roman");

    const textWidth2 =
      (doc.getStringUnitWidth(headingText2) * fontSize) /
      doc.internal.scaleFactor;

    const textWidth3 =
      (doc.getStringUnitWidth(headingText3) * fontSize) /
      doc.internal.scaleFactor;

    const tableYStart = 35; // You can adjust this value to control the space between text and the table

    doc.setFontSize(fontSize);

    const xCoordinate2 = (pageWidth * 1.5 - textWidth2) / 2;

    doc.text(headingText2, xCoordinate2, 10); // Adjust the Y-coordinate as needed

    const xCoordinate3 = (pageWidth * 1.5 - textWidth3) / 2;

    doc.text(headingText3, xCoordinate3, 30); // Adjust the Y-coordinate as needed
    doc.text(headingText4, xCoordinate4, 20); // Adjust the Y-coordinate (e.g., 20) as needed

    doc.addImage(imgPath, "PNG", 5, 5, 25, 25); // Adjust the size as needed

    doc.autoTable({
      html: "#my-generatepdf",
      theme: "grid",
      tableWidth: "auto",
      columnStyles: {
        3: { cellWidth: "wrap" }
      },
      startY: tableYStart,
      margin: { top: 5, right: 15, bottom: 5, left: 15 }, // Decrease cell padding to 5 mm
      styles: {
        fontSize: 8 // Reduce font size for table data to 8 points
      },
      columnWidth: { 0: 20, 1: 30, 2: 40 } // Adjust column widths as needed
    });

    doc.save("ConfirmationOfEmployeeRollsReport.pdf");
  }
  const showNotification = (type, message) => {
    if (type === "success") {
      Swal.fire("Success", message, "success");
    } else if (type === "error") {
      Swal.fire("Error", message, "error");
    } else if (type === "warning") {
      Swal.fire("Warning", message, "warning");
    } else if (type === "info") {
      Swal.fire("info", message, "info");
    }
  };
  const NumberValidation = (e) => {
    var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;

    if ((keyCode >= 48 && keyCode <= 57) || keyCode === 46) {
      var value = Number(e.target.value + e.key) || 0;
      return isValidNumber(value);
    } else {
      e.preventDefault();
      showNotification("warning", "Enter digits only");
      return false;
    }
  };

  function isValidNumber(number) {
    return 0 <= number && number <= 10;
  }
  const [searchText, setSearchText] = useState("");
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const filteredData =
    searchText.length > 0 ? tableData?.filter((item) => { return (item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase())); })); })
      : tableData;
  const calculateDAPercentage = () => {
    const { basic_pay_earnings, da_earnings } = formik3.values; if (!basic_pay_earnings || !da_earnings) return 0;
    const percentage = (da_earnings / basic_pay_earnings) * 100; return percentage.toFixed(2);
  };
  const calculateHRAPercentage = () => {
    const { basic_pay_earnings, hra_earnings } = formik3.values;

    if (!basic_pay_earnings || !hra_earnings) return 0;

    const percentage = (hra_earnings / basic_pay_earnings) * 100;
    return percentage.toFixed(2);
  };
  const calculateIRPercentage = () => {
    const { basic_pay_earnings, ir_earnings } = formik3.values;

    if (!basic_pay_earnings || !ir_earnings) return 0;

    const percentage = (ir_earnings / basic_pay_earnings) * 100;
    return percentage.toFixed(2);
  };
  const calculateEPFPercentage = () => {
    const { basic_pay_earnings, epf_deductions } = formik3.values;

    if (!basic_pay_earnings || !epf_deductions) return 0;

    const percentage = (epf_deductions / basic_pay_earnings) * 100;
    return percentage.toFixed(2);
  };
  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container fluid style={{ width: "90%" }}>
        <OFMSUI.Row>
          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className='page-titlespacing'
          >
            <div className='inner-herbpage-service-title1'>
              <h1 style={{ alignItems: 'center' }}>
                Confirmation of Employee on Rolls
              </h1>
            </div>
          </OFMSUI.Col>

          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className='page-titlespacing'
          >
            <button
              className="btn btn-primary btn-sm"
              style={{
                textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff"
              }}
              type="reset"
              onClick={() => history.goBack()}
            >
              <FaFastBackward /> &nbsp;Back
            </button>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container className='outer-page-content-container' fluid style={{ width: "90%" }}>
        <FormikProvider value={formik3}>
          <Form onSubmit={formik3.handleSubmit}>
            &nbsp;
            <OFMSUI.Row>
              {" "}
              <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="">
                <th>
                  Employee Type:
                </th>

                <Field
                  name="emptype_id"
                  className={
                    formik3.touched.emptype_id && formik3.errors.emptype_id
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  onChange={(e) => {
                    formik3.handleChange(e);
                  }}
                  component="select"
                >
                  <option>Select</option>
                  {EmpTypeList}
                </Field>
                {formik3.touched.emptype_id && formik3.errors.emptype_id ? (
                  <div className="invalid-feedback">
                    {formik3.errors.emptype_id}
                  </div>
                ) : null}
              </Col>
              <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <th>
                  District name:
                </th>
                <Field
                  component="select"
                  name="district"
                  className={
                    formik3.touched.district && formik3.errors.district
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  onChange={(e) => formik3.handleChange(e)}
                >
                  {formik3.touched.district && formik3.errors.district ? (
                    <div className="invalid-feedback">
                      {formik3.errors.district}
                    </div>
                  ) : null}
                  <option value="">Select</option>
                  {distList}
                </Field>
              </Col>
              <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <center>
                  {" "}
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    style={{ marginTop: "26px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }}
                  >
                    Get Details
                  </button>
                </center>
              </Col>
            </OFMSUI.Row>
            &nbsp;
            <OFMSUI.Row>
              {" "}
              {tableenable && (
                <>
                  <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div
                            className="input-group-text group_txt11"
                            id="btnGroupAddon"
                          >
                            <AiOutlineSearch />
                          </div>
                        </div>

                        <input
                          type="text"
                          id="#filterInput"
                          placeholder="Search
"
                          style={{ width: "15%" }}
                          className="form-control input-lg"
                          value={searchText}
                          onChange={handleSearch}
                        ></input>
                      </div>
                    </OFMSUI.Col>

                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={9}
                      xl={9}
                      xxl={9}
                      className=" mb-2 float-end"
                    >
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        style={{ float: "right", color: "#fff" }}
                      >
                        <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className="download-table-xls-button"
                          table="my-generatepdf"
                          filename="PayRollReports"
                          sheet="tablexls"
                          buttonText="Excel"
                        >
                          <FaFileExcel style={{ color: "#fff" }} />
                        </ReactHTMLTableToExcel>
                      </button>
                      <OFMSUI.Col>
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={generatepdf}
                          style={{ float: "right", marginLeft: "3px" }}
                        >
                          PDF
                          <MdOutlinePictureAsPdf />
                        </button>
                      </OFMSUI.Col>
                    </OFMSUI.Col>
                  </OFMSUI.Row>
                  <div style={{ overflow: "auto", height: "700px" }}>
                    <Table striped bordered hover id="my-generatepdf">
                      <thead
                        className="fw-bold"
                        style={{ position: "sticky", top: "0px" }}
                      >
                        <tr class="table_countshead">
                          <th>S No.</th>
                          <th>Employee Id</th>
                          <th>Employee Name</th>
                          <th>Designation</th>
                          <th>Place of Work / Location </th>
                          {/* <th>Earnings</th>

                          <th>Deductions </th>

                          <th>Loan </th>

                          <th>Net Salary </th> */}

                          <th>on Roll</th>

                          <th>On long-leave</th>
                          <th>Suspended</th>
                          <th>Retired </th>
                          {/* <th>Retired</th> */}
                        </tr>
                      </thead>

                      <tbody>
                        {filteredData?.length === 0 ? (
                          <tr>
                            <td colSpan={9} style={{ textAlign: "center" }}>
                              No data found
                            </td>
                          </tr>
                        ) : (
                          filteredData?.map((tableData, i) => (
                            <tr key={i}>
                              <td
                                style={{ textAlign: "center", width: "60px" }}
                              >
                                {" "}
                                {1 + i}
                              </td>
                              {saveUser == "GMADM" ? (<td style={{ width: "7%" }}> <Link style={{ textDecoration: "none", cursor: "pointer" }} onClick={() => getEmpInfo(tableData.emp_type, tableData.emp_id)}>{tableData.emp_id}</Link> </td>) : (<td style={{ width: "7%" }}> {tableData.emp_id} </td>)}
                              <td>{tableData.name}</td>
                              <td style={{ width: "10%" }}>
                                {tableData.designation}
                              </td>
                              <td style={{ width: "10%" }}>
                                {tableData.work_location1 ||
                                  tableData.work_location2}
                              </td>
                              {/* <td style={{ width: "5%" }}>
                                {tableData.earnings}
                              </td>
                              <td style={{ width: "5%" }}>
                                {tableData.deductions}
                              </td>
                              <td style={{ width: "5%" }}>{tableData.loan}</td>
                              <td style={{ width: "5%" }}>
                                {parseFloat(
                                  tableData.earnings -
                                  (tableData.deductions + tableData.loan)
                                )}
                              </td> */}
                              <td>
                                <input
                                  type="radio"
                                  name={`working_status${i}`}
                                  value="working"
                                  checked={
                                    selectedList?.find(
                                      (item) => item.emp_id === tableData.emp_id
                                    )?.working_status === "working"
                                  }
                                  onChange={(e) =>
                                    handleRadioChange(
                                      e,
                                      tableData.emp_id,
                                      "working"
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="radio"
                                  name={`working_status${i}`}
                                  value="longleave"
                                  checked={
                                    selectedList?.find(
                                      (item) => item.emp_id === tableData.emp_id
                                    )?.working_status === "longleave"
                                  }
                                  onChange={(e) =>
                                    handleRadioChange(
                                      e,
                                      tableData.emp_id,
                                      "longleave"
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="radio"
                                  name={`working_status${i}`}
                                  value="suspended"
                                  checked={
                                    selectedList?.find(
                                      (item) => item.emp_id === tableData.emp_id
                                    )?.working_status === "suspended"
                                  }
                                  onChange={(e) =>
                                    handleRadioChange(
                                      e,
                                      tableData.emp_id,
                                      "suspended"
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="radio"
                                  name={`working_status${i}`}
                                  value="resigned"
                                  checked={
                                    selectedList?.find(
                                      (item) => item.emp_id === tableData.emp_id
                                    )?.working_status === "resigned"
                                  }
                                  onChange={(e) =>
                                    handleRadioChange(
                                      e,
                                      tableData.emp_id,
                                      "resigned"
                                    )
                                  }
                                />
                              </td>
                              {/* <td>
                                <input
                                  type="radio"
                                  name={`working_status${i}`}
                                  value="retired"
                                  checked={
                                    selectedList?.find(
                                      (item) => item.emp_id === tableData.emp_id
                                    )?.working_status === "Retired"
                                  }
                                  onChange={(e) =>
                                    handleRadioChange(
                                      e,
                                      tableData.emp_id,
                                      "retired"
                                    )
                                  }
                                />
                              </td> */}
                            </tr>
                          ))
                        )}
                      </tbody>
                      {/* <tfoot
                        className="fw-bold"
                        style={{
                          position: "sticky",
                          bottom: "0px",
                          backgroundColor: "white"
                        }}
                      >
                        <tr class="table_countshead">
                          <td style={{ textAlign: "end" }} colSpan={5}>
                            {" "}
                            Total Amount in Rs{" "}
                          </td>
                          <td>
                            {filteredData
                              ?.reduce((a, v) => a + v.earnings, 0)
                              .toFixed(2)
                              .toLocaleString("en-IN")}
                          </td>
                          <td>
                            {filteredData
                              ?.reduce((a, v) => a + v.deductions, 0)
                              .toFixed(2)
                              .toLocaleString("en-IN")}
                          </td>
                          <td>
                            {filteredData
                              ?.reduce((a, v) => a + v.loan, 0)
                              .toFixed(2)
                              .toLocaleString("en-IN")}
                          </td>
                          <td>
                            {(
                              filteredData?.reduce(
                                (a, v) => a + v.earnings,
                                0
                              ) -
                              (filteredData?.reduce(
                                (a, v) => a + v.deductions,
                                0
                              ) +
                                filteredData?.reduce((a, v) => a + v.loan, 0))
                            )
                              .toFixed(2)
                              .toLocaleString("en-IN")}
                          </td>
                          <td colSpan={4}></td>
                        </tr>
                      </tfoot> */}
                    </Table>
                  </div>
                  <center>
                    {" "}
                    <button
                      className="btn btn-success btn-sm"
                      type="button"
                      onClick={() => {
                        // console.log(selectedList, "list");
                        updateWorkStatus();
                      }}
                    >
                      Update
                    </button>
                  </center>
                </>
              )}
            </OFMSUI.Row>
            {viewEnable && (
              <>
                <OFMSUI.Row>
                  <OFMSUI.Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    className=" mb-3"
                  >
                    <button
                      className="btn btn-primary mb-2"
                      type="button"
                      style={{ float: "right" }}
                      onClick={() => backing()}
                    >
                      Back
                    </button>
                  </OFMSUI.Col>
                </OFMSUI.Row>
                <Table bordered>
                  <tbody>
                    <div style={{ textAlign: "left" }}>
                      <h5 style={{ color: "#004687" }}>
                        <b style={{ color: "#0e6793" }}>
                          <u>
                            {" "}
                            <h4>
                              Personal Details
                            </h4>
                          </u>
                        </b>
                      </h5>
                    </div>
                    <div class="col-md-60">
                      <Row>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Employee ID</th>

                          <Field
                            name="emp_id"
                            className={
                              formik3.touched.emp_id && formik3.errors.emp_id
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Prefix</th>

                          <Field
                            name="prefix"
                                                  component="select"

                            className={
                              formik3.touched.prefix && formik3.errors.prefix
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={formik3.handleChange}
                          >

                                                
                      <option value="">Select</option>

                                            <option value="MR">MR</option>
                      <option value="Mrs.">Mrs.</option>
                      <option value="SMT">SMT</option>
                      <option value="Mr.">Mr.</option>
                      <option value="Ms.">Ms.</option>
                      <option value="Smt">Smt</option>
                      <option value="Mr">Mr</option>
                      <option value="Sri">Sri</option>
                    </Field>

                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}> First Name</th>

                          <Field
                            name="firstname"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            className={
                              formik3.touched.firstname &&
                                formik3.errors.firstname
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Last Name</th>

                          <Field
                            name="lastname"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            className={
                              formik3.touched.lastname && formik3.errors.lastname
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Surname</th>

                          <Field
                            name="surname"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            className={
                              formik3.touched.surname && formik3.errors.surname
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Father name:</th>

                          <Field
                            name="fathername"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            className={
                              formik3.touched.fathername &&
                                formik3.errors.fathername
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Sex</th>

                        <Field
                          name="sex"
                          component="select"
                          onChange={(e) => {
                            formik3.handleChange(e);
                          }}
                          className={
                            formik3.touched.sex && formik3.errors.sex
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        >
                          <option value="">Select</option>
                          <option value="M">Male</option>
                          <option value="F">Female</option>
                        </Field>
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>
                            {" "}
                            Employee Type
                          </th>

                          <Field
                            name="emp_type"
                            className={
                              formik3.touched.emp_type && formik3.errors.emp_type
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={(e) => {
                              formik3.handleChange(e);
                              setSelectedEmpType(e.target.value);
                            }}
                            component="select"
                          >
                            <option>Select</option>
                            {EmpTypeList}
                          </Field>
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Bank Name</th>

                          <Field
                            component="select"
                            name="bank_name"
                            className={
                              formik3.touched.bank_name &&
                                formik3.errors.bank_name
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          >
                            <option value="">--Select--</option>
                            {bankNamesList}
                          </Field>
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Designation</th>

                          <Field
                            name="designation"
                            component="select"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            className={
                              formik3.touched.designation &&
                                formik3.errors.designation
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          >
                            <option value="">Select</option>
                            {prdesignationlist}
                          </Field>
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Branch Code</th>

                          <Field
                            name="branch_code"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            className={
                              formik3.touched.branch_code &&
                                formik3.errors.branch_code
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Account No.</th>

                          <Field
                            name="account_no"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            className={
                              formik3.touched.account_no &&
                                formik3.errors.account_no
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Ifsc Code</th>

                          <Field
                            name="ifsc"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            className={
                              formik3.touched.ifsc && formik3.errors.ifsc
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                  </tbody>
                </Table>
                {(selectedEmpType === "1" ||
                  selectedEmpType === "2" ||
                  selectedEmpType === "5") && (
                    <>
                      <div style={{ textAlign: "left" }}>
                        <h5 style={{ color: "#004687" }}>
                          <b style={{ color: "#0e6793" }}>
                            <u>
                              {" "}
                              <h4>
                                Earnings
                              </h4>
                            </u>
                          </b>
                        </h5>
                      </div>

                      <div class="col-md-60" id="fieldName">
                        <Row>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}> Basic Pay</th>

                            <Field
                              name="basic_pay_earnings"
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.basic_pay_earnings &&
                                  formik3.errors.basic_pay_earnings
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}> Personal Pay</th>

                            <Field
                              name="per_pay_earnings"
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.per_pay_earnings &&
                                  formik3.errors.per_pay_earningsearnings
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>Special Pay</th>

                            <Field
                              name="spl_pay_earnings"
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.spl_pay_earnings &&
                                  formik3.errors.spl_pay_earnings
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={1}
                            xl={1}
                            xxl={1}
                            className=""
                          >
                            {" "}
                            <th style={{ fontFamily: "roboto" }}>
                              D.A. (Percentage)
                            </th>
                            <Field
                              name="da_earnings_per"
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                              value={`${calculateDAPercentage()} `}
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.da_earnings_per &&
                                  formik3.errors.da_earnings_per
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={2}
                            xl={2}
                            xxl={2}
                            className=""
                          >
                            {" "}
                            <th style={{ fontFamily: "roboto" }}>D.A.</th>
                            <Field
                              name="da_earnings"
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.da_earnings &&
                                  formik3.errors.da_earnings
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                            <ErrorMessage
                              name="da_earnings"
                              component="div"
                              className="invalid-feedback"
                            />
                          </Col>
                        </Row>
                        <Row> </Row>
                        <Row>
                          {" "}
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>
                              {" "}
                              H.R.A (percentage)
                            </th>

                            <Field
                              name="hra_earnings_per"
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              value={`${calculateHRAPercentage()} `}
                              className={
                                formik3.touched.hra_earnings_per &&
                                  formik3.errors.hra_earnings_per
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}> H.R.A</th>

                            <Field
                              name="hra_earnings"
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.hra_earnings &&
                                  formik3.errors.hra_earnings
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                            <ErrorMessage
                              name="hra_earnings"
                              component="div"
                              className="invalid-feedback"
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}> C.C.A</th>

                            <Field
                              name="cca_earnings"
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.cca_earnings &&
                                  formik3.errors.cca_earnings
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}> G.P</th>

                            <Field
                              name="gp_earnings"
                              className={
                                formik3.touched.gp_earnings &&
                                  formik3.errors.gp_earnings
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>IR (percentage)</th>

                            <Field
                              name="ir_earnings_per"
                              className={
                                formik3.touched.ir_earnings_per &&
                                  formik3.errors.ir_earnings_per
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              value={`${calculateIRPercentage()} `}
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>IR</th>

                            <Field
                              name="ir_earnings"
                              className={
                                formik3.touched.ir_earnings &&
                                  formik3.errors.ir_earnings
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />

                            <ErrorMessage
                              name="ir_earnings"
                              component="div"
                              className="invalid-feedback"
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}> Medical</th>

                            <Field
                              name="medical_earnings"
                              className={
                                formik3.touched.medical_earnings &&
                                  formik3.errors.medical_earnings
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>C.A</th>

                            <Field
                              name="ca_earnings"
                              className={
                                formik3.touched.ca_earnings &&
                                  formik3.errors.ca_earnings
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          {" "}
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>
                              Special Allowance.
                            </th>

                            <Field
                              name="spl_all"
                              className={
                                formik3.touched.spl_all && formik3.errors.spl_all
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>Misc.(H.C)</th>

                            <Field
                              name="misc_h_c"
                              className={
                                formik3.touched.misc_h_c && formik3.errors.misc_h_c
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>
                              Addl. HRA(Tribal Area)
                            </th>

                            <Field
                              name="addl_hra"
                              className={
                                formik3.touched.addl_hra && formik3.errors.addl_hra
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>SCA(Tribal Area)</th>

                            <Field
                              name="sca"
                              className={
                                formik3.touched.sca && formik3.errors.sca
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={2}
                            xl={2}
                            xxl={2}
                            className=""
                          >
                            <th
                              style={{
                                fontFamily: "roboto",
                                color: "green",
                                fontWeight: "1000"
                              }}
                            >
                              <u>Total Earnings</u>
                            </th>

                            <Field
                              name="totalEarnings"
                              className={
                                formik3.touched.totalEarnings &&
                                  formik3.errors.totalEarnings
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              value={fieldNames
                                .reduce(
                                  (total, fieldName) =>
                                    total + parseFloat(formik3.values[fieldName] || 0),
                                  0
                                )
                                .toLocaleString({
                                  style: "currency",
                                  currency: "INR",
                                  maximumFractionDigits: 0
                                })}
                              readOnly
                            />
                          </Col>
                        </Row>
                      </div>

                      <div style={{ textAlign: "left" }} id="deductionNames">
                        <h5 style={{ color: "#004687" }}>
                          <b style={{ color: "#0e6793" }}>
                            <u>
                              {" "}
                              <h4>
                                Deductions
                              </h4>
                            </u>
                          </b>
                        </h5>
                      </div>
                      <div class="col-md-60">
                        <Row>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>
                              GPF(Subscription)
                            </th>

                            <Field
                              name="gpfs_deductions"
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.gpfs_deductions &&
                                  formik3.errors.gpfs_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              onChange={formik3.handleChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>
                              GPF(Addl. Subscription)
                            </th>

                            <Field
                              name="gpfsa_deductions"
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.gpfsa_deductions &&
                                  formik3.errors.gpfsa_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>GPF(Loan)</th>

                            <Field
                              name="gpfl_deductions"
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.gpfl_deductions &&
                                  formik3.errors.gpfl_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            {" "}
                            <th style={{ fontFamily: "roboto" }}>
                              APGLI(Subscription)
                            </th>
                            <Field
                              name="apglis_deductions"
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.apglis_deductions &&
                                  formik3.errors.apglis_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          {" "}
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            {" "}
                            <th style={{ fontFamily: "roboto" }}>APGLI(Loan)</th>
                            <Field
                              name="apglil_deductions"
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.apglil_deductions &&
                                  formik3.errors.apglil_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>GIS</th>

                            <Field
                              name="gis_deductions"
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.gis_deductions &&
                                  formik3.errors.gis_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>
                              LIC(Subscription)
                            </th>

                            <Field
                              name="lic_deductions"
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              className={
                                formik3.touched.lic_deductions &&
                                  formik3.errors.lic_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>License Fee</th>

                            <Field
                              name="license_deductions"
                              className={
                                formik3.touched.license_deductions &&
                                  formik3.errors.license_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          {" "}
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>Con.Ded</th>

                            <Field
                              name="con_decd_deductions"
                              className={
                                formik3.touched.con_decd_deductions &&
                                  formik3.errors.con_decd_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>EPF (percentage)</th>

                            <Field
                              name="epf_deductions_per"
                              className={
                                formik3.touched.epf_deductions_per &&
                                  formik3.errors.epf_deductions_per
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              value={`${calculateEPFPercentage()} `}
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>EPF</th>

                            <Field
                              name="epf_deductions"
                              className={
                                formik3.touched.epf_deductions &&
                                  formik3.errors.epf_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}> EPF Loan</th>

                            <Field
                              name="epf_l_deductions"
                              className={
                                formik3.touched.epf_l_deductions &&
                                  formik3.errors.epf_l_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>Voluntary PF</th>

                            <Field
                              name="vpf_deductions"
                              className={
                                formik3.touched.vpf_deductions &&
                                  formik3.errors.vpf_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>PPF</th>

                            <Field
                              name="ppf_deductions"
                              className={
                                formik3.touched.ppf_deductions &&
                                  formik3.errors.ppf_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}> RCS Cont</th>

                            <Field
                              name="rcs_cont_deductions"
                              className={
                                formik3.touched.rcs_cont_deductions &&
                                  formik3.errors.rcs_cont_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>CM's RF</th>

                            <Field
                              name="cmrf_deductions"
                              className={
                                formik3.touched.cmrf_deductions &&
                                  formik3.errors.cmrf_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>FCF</th>

                            <Field
                              name="fcf_deductions"
                              className={
                                formik3.touched.fcf_deductions &&
                                  formik3.errors.fcf_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}> House Rent</th>

                            <Field
                              name="house_rent_deductions"
                              className={
                                formik3.touched.house_rent_deductions &&
                                  formik3.errors.house_rent_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>Sal.Rec</th>

                            <Field
                              name="sal_rec_deductions"
                              className={
                                formik3.touched.sal_rec_deductions &&
                                  formik3.errors.sal_rec_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>P.T</th>

                            <Field
                              name="pt_deductions"
                              className={
                                formik3.touched.pt_deductions &&
                                  formik3.errors.pt_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>I.T.</th>

                            <Field
                              name="it_deductions"
                              className={
                                formik3.touched.it_deductions &&
                                  formik3.errors.it_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          {/* <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className=""
                    >
                      <th style={{ fontFamily: "roboto" }}>Postal RD</th>

                      <Field
                        name="postal_deductions"
                        className={
                          formik3.touched.postal_deductions && formik3.errors.postal_deductions
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        type="text" onKeyPress={(e) => NumberValidation(e)}

                        onChange={(e) => {
                          formik3.handleChange(e);
                        }}
                      />
                    </Col> */}
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={3}
                            xl={3}
                            xxl={3}
                            className=""
                          >
                            <th style={{ fontFamily: "roboto" }}>
                              Other Liabilities
                            </th>

                            <Field
                              name="other_deductions"
                              className={
                                formik3.touched.other_deductions &&
                                  formik3.errors.other_deductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              onChange={(e) => {
                                formik3.handleChange(e);
                              }}
                            />
                          </Col>
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={2}
                            xl={2}
                            xxl={2}
                            className=""
                          >
                            <th
                              style={{
                                fontFamily: "roboto",
                                color: "red",
                                fontWeight: "1000"
                              }}
                            >
                              <u>Total Deductions</u>
                            </th>

                            <Field
                              name="totalDeductions"
                              className={
                                formik3.touched.totalDeductions &&
                                  formik3.errors.totalDeductions
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              type="text"
                              onKeyPress={(e) => NumberValidation(e)}
                              value={deductionNames
                                .reduce(
                                  (total, deductionNames) =>
                                    total +
                                    parseFloat(formik3.values[deductionNames] || 0),
                                  0
                                )
                                .toLocaleString({
                                  style: "currency",
                                  currency: "INR",
                                  maximumFractionDigits: 0
                                })}
                              readOnly
                            />
                          </Col>
                        </Row>
                      </div>
                      <div style={{ textAlign: "left" }} id="LoanDeductions">
                        <h5 style={{ color: "#004687" }}>
                          <b style={{ color: "#0e6793" }}>
                            <u>
                              {" "}
                              <h4>
                                Loan Advances
                              </h4>
                            </u>
                          </b>
                        </h5>
                      </div>
                      <Table striped bordered hover id="my-table">
                        <thead className="fw-bold">
                          <tr className="table_countshead">
                            <th></th>
                            <th>
                              <h6>P I </h6>
                            </th>
                            <th>
                              <h6>T I </h6>
                            </th>
                            <th>
                              <h6>Amount</h6>
                            </th>
                            <th></th>
                            <th>
                              <h6>P I </h6>
                            </th>
                            <th>
                              <h6>T I </h6>
                            </th>
                            <th>
                              <h6>Amount</h6>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              CAR-Principal
                            </td>
                            <td>
                              <Field
                                name="car_a_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.car_a_loanpi &&
                                    formik3.errors.car_a_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="cyc_a_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.cyc_a_loanti &&
                                    formik3.errors.cyc_a_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="car_a_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.car_a_loan &&
                                    formik3.errors.car_a_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              CAR-Interest
                            </td>
                            <td>
                              <Field
                                name="car_i_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.car_i_loanpi &&
                                    formik3.errors.car_i_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="car_i_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.car_i_loanti &&
                                    formik3.errors.car_i_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="car_i_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.car_i_loan &&
                                    formik3.errors.car_i_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              Cycle-Principal
                            </td>
                            <td>
                              <Field
                                name="cyc_a_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.cyc_a_loanpi &&
                                    formik3.errors.cyc_a_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="cyc_a_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.cyc_a_loanti &&
                                    formik3.errors.cyc_a_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="cyc_a_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.cyc_a_loan &&
                                    formik3.errors.cyc_a_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              Cycle-Interest
                            </td>
                            <td>
                              <Field
                                name="cyc_i_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.cyc_i_loanpi &&
                                    formik3.errors.cyc_i_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="cyc_i_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.cyc_i_loanti &&
                                    formik3.errors.cyc_i_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="cyc_i_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.cyc_i_loan &&
                                    formik3.errors.cyc_i_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              MCA-Principal
                            </td>
                            <td>
                              <Field
                                name="mca_a_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.mca_a_loanpi &&
                                    formik3.errors.mca_a_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="mca_a_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.mca_a_loanti &&
                                    formik3.errors.mca_a_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="mca_a_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.mca_a_loan &&
                                    formik3.errors.mca_a_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              MCA-Interest
                            </td>
                            <td>
                              <Field
                                name="mca_i_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.mca_i_loanpi &&
                                    formik3.errors.mca_i_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="mca_i_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.mca_i_loanti &&
                                    formik3.errors.mca_i_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="mca_i_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.mca_i_loan &&
                                    formik3.errors.mca_i_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>

                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              MAR-Principal
                            </td>
                            <td>
                              <Field
                                name="mar_a_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.mar_a_loanpi &&
                                    formik3.errors.mar_a_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="mar_a_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.mar_a_loanti &&
                                    formik3.errors.mar_a_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="mar_a_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.mar_a_loan &&
                                    formik3.errors.mar_a_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              MAR-Interest
                            </td>
                            <td>
                              <Field
                                name="mar_i_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.mar_i_loanpi &&
                                    formik3.errors.mar_i_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="mar_i_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.mar_i_loanti &&
                                    formik3.errors.mar_i_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="mar_i_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.mar_i_loan &&
                                    formik3.errors.mar_i_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              MEDI-Principal
                            </td>
                            <td>
                              <Field
                                name="med_a_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.med_a_loanpi &&
                                    formik3.errors.med_a_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="med_a_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.med_a_loanti &&
                                    formik3.errors.med_a_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="med_a_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.med_a_loan &&
                                    formik3.errors.med_a_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              MEDI-Interest
                            </td>
                            <td>
                              <Field
                                name="med_a_i_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.med_a_i_loanpi &&
                                    formik3.errors.med_a_i_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="med_a_i_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.med_a_i_loanti &&
                                    formik3.errors.med_a_i_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="med_a_i_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.med_a_i_loan &&
                                    formik3.errors.med_a_i_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              HBA
                            </td>
                            <td>
                              <Field
                                name="hba_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hba_loanpi &&
                                    formik3.errors.hba_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="hba_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hba_loanti &&
                                    formik3.errors.hba_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="hba_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hba_loan && formik3.errors.hba_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              HBA-Interest
                            </td>
                            <td>
                              <Field
                                name="hba1_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hba1_loanpi &&
                                    formik3.errors.hba1_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="hba1_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hba1_loanti &&
                                    formik3.errors.hba1_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="hba1_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hba1_loan && formik3.errors.hba1_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              ADD HBA
                            </td>
                            <td>
                              <Field
                                name="add_hba_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.add_hba_loanpi &&
                                    formik3.errors.add_hba_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="add_hba_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.add_hba_loanti &&
                                    formik3.errors.add_hba_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="add_hba_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.add_hba_loan &&
                                    formik3.errors.add_hba_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              ADD HBA-Interest
                            </td>
                            <td>
                              <Field
                                name="add_hba1_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.add_hba1_loanpi &&
                                    formik3.errors.add_hba1_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="add_hba1_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.add_hba1_loanti &&
                                    formik3.errors.add_hba1_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="add_hba1_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.add_hba1_loan &&
                                    formik3.errors.add_hba1_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              Comp.Adv
                            </td>
                            <td>
                              <Field
                                name="comp_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.comp_loanpi &&
                                    formik3.errors.comp_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="comp_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.comp_loanti &&
                                    formik3.errors.comp_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="comp_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.comp_loan && formik3.errors.comp_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              Comp.Adv-Interest
                            </td>
                            <td>
                              <Field
                                name="comp1_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.comp1_loanpi &&
                                    formik3.errors.comp1_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="comp1_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.comp1_loanti &&
                                    formik3.errors.comp1_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="comp1_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.comp1_loan &&
                                    formik3.errors.comp1_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              HCESA-Principal
                            </td>
                            <td>
                              <Field
                                name="hcesa_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hcesa_loanpi &&
                                    formik3.errors.hcesa_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="hcesa_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hcesa_loanti &&
                                    formik3.errors.hcesa_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="hcesa_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hcesa_loan &&
                                    formik3.errors.hcesa_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              HCESA-Interest
                            </td>
                            <td>
                              <Field
                                name="hcesa_i_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hcesa_i_loanpi &&
                                    formik3.errors.hcesa_i_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="hcesa_i_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hcesa_i_loanti &&
                                    formik3.errors.hcesa_i_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="hcesa_i_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hcesa_i_loan &&
                                    formik3.errors.hcesa_i_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              HBA-Other Dept.
                            </td>
                            <td>
                              <Field
                                name="hbao_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hbao_loanpi &&
                                    formik3.errors.hbao_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="hbao_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hbao_loanti &&
                                    formik3.errors.hbao_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="hbao_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hbao_loan && formik3.errors.hbao_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              Personal Bank Loan
                            </td>
                            <td>
                              <Field
                                name="vij_bank_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.vij_bank_loanpi &&
                                    formik3.errors.vij_bank_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="vij_bank_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.vij_bank_loanti &&
                                    formik3.errors.vij_bank_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="vij_bank_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.vij_bank_loan &&
                                    formik3.errors.vij_bank_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              FA
                            </td>
                            <td>
                              <Field
                                name="fa_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.fa_loanpi && formik3.errors.fa_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="fa_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.fa_loanti && formik3.errors.fa_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="fa_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.fa_loan && formik3.errors.fa_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              EA
                            </td>
                            <td>
                              <Field
                                name="ea_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.ea_loanpi && formik3.errors.ea_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="ea_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.ea_loanti && formik3.errors.ea_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="ea_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.ea_loan && formik3.errors.ea_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              Spl.FA
                            </td>
                            <td>
                              <Field
                                name="sfa_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.sfa_loanpi &&
                                    formik3.errors.sfa_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="sfa_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.sfa_loanti &&
                                    formik3.errors.sfa_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="sfa_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.sfa_loan && formik3.errors.sfa_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              Sal.Adv
                            </td>
                            <td>
                              <Field
                                name="sal_adv_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.sal_adv_loanpi &&
                                    formik3.errors.sal_adv_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="sal_adv_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.sal_adv_loanti &&
                                    formik3.errors.sal_adv_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="sal_adv_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.sal_adv_loan &&
                                    formik3.errors.sal_adv_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              HR Arrear
                            </td>
                            <td>
                              <Field
                                name="hr_arrear_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hr_arrear_loanpi &&
                                    formik3.errors.hr_arrear_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="hr_arrear_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hr_arrear_loanti &&
                                    formik3.errors.hr_arrear_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="hr_arrear_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.hr_arrear_loan &&
                                    formik3.errors.hr_arrear_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              Cell/Telephone Charges
                            </td>
                            <td>
                              <Field
                                name="cell_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.cell_loanpi &&
                                    formik3.errors.cell_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="cell_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.cell_loanti &&
                                    formik3.errors.cell_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="cell_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.cell_loan && formik3.errors.cell_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                          <tr>
                            {" "}
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              Staff PL.
                            </td>
                            <td>
                              <Field
                                name="staff_pl_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.staff_pl_loanpi &&
                                    formik3.errors.staff_pl_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="staff_pl_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.staff_pl_loanti &&
                                    formik3.errors.staff_pl_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="staff_pl_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.staff_pl_loan &&
                                    formik3.errors.staff_pl_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                fontWeight: "700",
                                fontFamily: "roboto"
                              }}
                            >
                              Court
                            </td>
                            <td>
                              <Field
                                name="court_loanpi"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.court_loanpi &&
                                    formik3.errors.court_loanpi
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="court_loanti"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.court_loanti &&
                                    formik3.errors.court_loanti
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                            <td>
                              <Field
                                name="court_loan"
                                onChange={(e) => {
                                  formik3.handleChange(e);
                                }}
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                className={
                                  formik3.touched.court_loan &&
                                    formik3.errors.court_loan
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                              />
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                      <Row>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={2}
                          xl={2}
                          xxl={2}
                          className=""
                          style={{ marginLeft: "auto" }}
                        >
                          <th
                            style={{
                              fontFamily: "roboto",
                              color: "red",
                              fontWeight: "800"
                            }}
                          >
                            <u>Loan Advances Total</u>
                          </th>

                          <Field
                            name="totalloanAdvances"
                            className={
                              formik3.touched.totalloanAdvances &&
                                formik3.errors.totalloanAdvances
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            value={LoanDeductions.reduce(
                              (total, LoanDeductions) =>
                                total +
                                parseFloat(formik3.values[LoanDeductions] || 0),
                              0
                            ).toLocaleString({
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0
                            })}
                            readOnly
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={2}
                          xl={2}
                          xxl={2}
                          className=""
                          style={{ marginLeft: "auto" }}
                        >
                          <th
                            style={{
                              fontFamily: "roboto",
                              color: "green",
                              fontWeight: "800",
                              fontSize: ""
                            }}
                          >
                            <u>Net Salary</u>
                          </th>

                          <Field
                            name="netSalary"
                            className={
                              formik3.touched.netSalary && formik3.errors.netSalary
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            value={totalSum.toLocaleString({
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0
                            })}
                            readOnly
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                {selectedEmpType === "3" && (
                  <>
                    <div style={{ textAlign: "left" }} id="Earnings_3">
                      <h5 style={{ color: "#004687" }}>
                        <b style={{ color: "#0e6793" }}>
                          <u>
                            {" "}
                            <h4>
                              Earnings
                            </h4>
                          </u>
                        </b>
                      </h5>
                    </div>
                    <div class="col-md-60">
                      <Row>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Place of Work</th>

                          <Field
                            name="os_work_place"
                            className={
                              formik3.touched.os_work_place &&
                                formik3.errors.os_work_place
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={formik3.handleChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}> Location</th>

                          <Field
                            name="os_location"
                            className={
                              formik3.touched.os_location &&
                                formik3.errors.os_location
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={formik3.handleChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}> Basic Pay</th>

                          <Field
                            name="os_basic_pay_earnings"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.os_basic_pay_earnings &&
                                formik3.errors.os_basic_pay_earnings
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}> H.R.A</th>

                          <Field
                            name="os_hra_earnings"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.os_hra_earnings &&
                                formik3.errors.os_hra_earnings
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Medical</th>

                          <Field
                            name="os_medical_earnings"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.os_medical_earnings &&
                                formik3.errors.os_medical_earnings
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>C.A</th>

                          <Field
                            name="os_ca_earnings"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.os_ca_earnings &&
                                formik3.errors.os_ca_earnings
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Performance</th>

                          <Field
                            name="os_performance_earnings"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            className={
                              formik3.touched.os_performance_earnings &&
                                formik3.errors.os_performance_earnings
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>
                            Employer's Contribution to EPF
                          </th>

                          <Field
                            name="os_ec_epf"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            className={
                              formik3.touched.os_ec_epf && formik3.errors.os_ec_epf
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                          />
                        </Col>
                      </Row>
                    </div>
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className=""
                        style={{ marginLeft: "auto" }}
                      >
                        <th
                          style={{
                            fontFamily: "roboto",
                            color: "green",
                            fontWeight: "800"
                          }}
                        >
                          <u>Earnings Total</u>
                        </th>

                        <Field
                          name="totalEarnings_3"
                          className={
                            formik3.touched.totalEarnings_3 &&
                              formik3.errors.totalEarnings_3
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          value={Earnings_3.reduce(
                            (total, Earnings_3) =>
                              total + parseFloat(formik3.values[Earnings_3] || 0),
                            0
                          ).toLocaleString({
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 0
                          })}
                          readOnly
                          onChange={(e) => {
                            formik3.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>
                    <div style={{ textAlign: "left" }} id="Deductions_3">
                      <h5 style={{ color: "#004687" }}>
                        <b style={{ color: "#0e6793" }}>
                          <u>
                            {" "}
                            <h4>
                              Deductions
                            </h4>
                          </u>
                        </b>
                      </h5>
                    </div>
                    <div class="col-md-60">
                      <Row>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>
                            {" "}
                            Employees Share(EPF)
                          </th>

                          <Field
                            name="os_ees_epf_deductions"
                            className={
                              formik3.touched.os_ees_epf_deductions &&
                                formik3.errors.os_ees_epf_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={formik3.handleChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>
                            Employers Share(EPF)
                          </th>

                          <Field
                            name="os_ers_epf_deductions"
                            className={
                              formik3.touched.os_ers_epf_deductions &&
                                formik3.errors.os_ers_epf_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={formik3.handleChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>
                            {" "}
                            Professional Tax
                          </th>

                          <Field
                            name="os_prof_tax_deductions"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.os_prof_tax_deductions &&
                                formik3.errors.os_prof_tax_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>
                            {" "}
                            Other Liabilities
                          </th>

                          <Field
                            name="os_other_deductions"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.os_other_deductions &&
                                formik3.errors.os_other_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className=""
                        style={{ marginLeft: "auto" }}
                      >
                        <th
                          style={{
                            fontFamily: "roboto",
                            color: "red",
                            fontWeight: "800"
                          }}
                        >
                          <u>Deductions Total</u>
                        </th>

                        <Field
                          name="totalDeductions_3"
                          className={
                            formik3.touched.totalDeductions_3 &&
                              formik3.errors.totalDeductions_3
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          value={Deductions_3.reduce(
                            (total, Deductions_3) =>
                              total + parseFloat(formik3.values[Deductions_3] || 0),
                            0
                          ).toLocaleString({
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 0
                          })}
                          readOnly
                          onChange={(e) => {
                            formik3.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className=""
                        style={{ marginLeft: "auto" }}
                      >
                        <th
                          style={{
                            fontFamily: "roboto",
                            color: "green",
                            fontWeight: "800",
                            fontSize: ""
                          }}
                        >
                          <u>NET SALARY</u>
                        </th>

                        <Field
                          name="netSalary_3"
                          className={
                            formik3.touched.netSalary_3 && formik3.errors.netSalary_3
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          value={totalSum_3.toLocaleString({
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 0
                          })}
                          readOnly
                          onChange={(e) => {
                            formik3.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                {selectedEmpType === "4" && (
                  <>
                    <div style={{ textAlign: "left" }} id="Earnings_3">
                      <h5 style={{ color: "#004687" }}>
                        <b style={{ color: "#0e6793" }}>
                          <u>
                            {" "}
                            <h4>
                              Earnings
                            </h4>
                          </u>
                        </b>
                      </h5>
                    </div>
                    <div class="col-md-60">
                      <Row>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>Place of Work</th>

                          <Field
                            name="os_work_place"
                            className={
                              formik3.touched.os_work_place &&
                                formik3.errors.os_work_place
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={formik3.handleChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}> Location</th>

                          <Field
                            name="os_location"
                            className={
                              formik3.touched.os_location &&
                                formik3.errors.os_location
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={formik3.handleChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}> Earnings</th>

                          <Field
                            name="nmr_gross_earnings"
                            className={
                              formik3.touched.nmr_gross_earnings &&
                                formik3.errors.nmr_gross_earnings
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={formik3.handleChange}
                          />
                        </Col>
                      </Row>
                    </div>
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className=""
                        style={{ marginLeft: "auto" }}
                      >
                        <th
                          style={{
                            fontFamily: "roboto",
                            color: "darkgreen",
                            fontWeight: "800"
                          }}
                        >
                          <u>Gross Earnings</u>
                        </th>

                        <Field
                          name="totalEarnings_4"
                          className={
                            formik3.touched.totalEarnings_4 &&
                              formik3.errors.totalEarnings_4
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          value={Earnings_4.reduce(
                            (total, Earnings_4) =>
                              total + parseFloat(formik3.values[Earnings_4] || 0),
                            0
                          ).toLocaleString({
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 0
                          })}
                          readOnly
                          onChange={(e) => {
                            formik3.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>
                    <div style={{ textAlign: "left" }} id="Deductions_3">
                      <h5 style={{ color: "#004687" }}>
                        <b style={{ color: "#0e6793" }}>
                          <u>
                            {" "}
                            <h4>
                              Deductions
                            </h4>
                          </u>
                        </b>
                      </h5>
                    </div>
                    <div class="col-md-60">
                      <Row>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>EPF</th>

                          <Field
                            name="os_ees_epf_deductions"
                            className={
                              formik3.touched.os_ees_epf_deductions &&
                                formik3.errors.os_ees_epf_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={formik3.handleChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>
                            {" "}
                            Professional Tax
                          </th>

                          <Field
                            name="os_prof_tax_deductions"
                            className={
                              formik3.touched.os_prof_tax_deductions &&
                                formik3.errors.os_prof_tax_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            onChange={formik3.handleChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}> TDS</th>

                          <Field
                            name="nmr_tds_deductions"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.nmr_tds_deductions &&
                                formik3.errors.nmr_tds_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>

                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}> FA</th>

                          <Field
                            name="nmr_fa_deductions"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.nmr_fa_deductions &&
                                formik3.errors.nmr_fa_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}> EA</th>

                          <Field
                            name="nmr_ea_deductions"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.nmr_ea_deductions &&
                                formik3.errors.nmr_ea_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}> MA</th>

                          <Field
                            name="nmr_ma_deductions"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.nmr_ma_deductions &&
                                formik3.errors.nmr_ma_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}> LIC</th>

                          <Field
                            name="nmr_lic_deductions"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.nmr_lic_deductions &&
                                formik3.errors.nmr_lic_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}>
                            {" "}
                            Other Liabilities
                          </th>

                          <Field
                            name="nmr_otherliab_deductions"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.nmr_otherliab_deductions &&
                                formik3.errors.nmr_otherliab_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className=""
                        >
                          <th style={{ fontFamily: "roboto" }}> Postal RD</th>

                          <Field
                            name="nmr_postalrd_deductions"
                            onChange={(e) => {
                              formik3.handleChange(e);
                            }}
                            type="text"
                            onKeyPress={(e) => NumberValidation(e)}
                            className={
                              formik3.touched.nmr_postalrd_deductions &&
                                formik3.errors.nmr_postalrd_deductions
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className=""
                        style={{ marginLeft: "auto" }}
                      >
                        <th
                          style={{
                            fontFamily: "roboto",
                            color: "red",
                            fontWeight: "800"
                          }}
                        >
                          <u>Deductions Total</u>
                        </th>

                        <Field
                          name="totalDeductions_4"
                          className={
                            formik3.touched.totalDeductions_4 &&
                              formik3.errors.totalDeductions_4
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          value={Deductions_4.reduce(
                            (total, Deductions_4) =>
                              total + parseFloat(formik3.values[Deductions_4] || 0),
                            0
                          ).toLocaleString({
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 0
                          })}
                          readOnly
                          onChange={(e) => {
                            formik3.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        xxl={2}
                        className=""
                        style={{ marginLeft: "auto" }}
                      >
                        <th
                          style={{
                            fontFamily: "roboto",
                            color: "green",
                            fontWeight: "800",
                            fontSize: ""
                          }}
                        >
                          <u>NET SALARY</u>
                        </th>

                        <Field
                          name="netSalary_4"
                          className={
                            formik3.touched.netSalary_4 && formik3.errors.netSalary_4
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          type="text"
                          onKeyPress={(e) => NumberValidation(e)}
                          value={totalSum_4.toLocaleString({
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 0
                          })}
                          readOnly
                          onChange={(e) => {
                            formik3.handleChange(e);
                          }}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                {(formik3.values.emptype_id === "1" || formik3.values.emptype_id === "2" || formik3.values.emptype_id === "5" ||
                  change === 1 || change === 2 || change === 5 ||
                  selectedEmpType === 1 || selectedEmpType === 2 || selectedEmpType === 5) && (
                    <center>
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => ConfirmEmpUpdateReport()}
                      >
                        Update
                      </button>
                    </center>
                  )}

                {(formik3.values.emptype_id == "3" && change == "3" && selectedEmpType == "3") && (
                  <center>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => ConfirmEmpUpdateReport3()}
                    >
                      Update
                    </button>
                  </center>
                )}
                {(formik3.values.emptype_id == "3" && change == "3" && selectedEmpType == "1") && (
                  <center>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => updateEmployeeDetailsToReg()}
                    >
                      Update
                    </button>
                  </center>
                )}
                {(formik3.values.emptype_id == "4" && change == "4" && selectedEmpType == "4") && (
                  <center>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => ConfirmEmpUpdateReport4()}
                    >
                      Update
                    </button>
                  </center>
                )}
                {(formik3.values.emptype_id == "4" && change == "4" && selectedEmpType == "1") && (
                  <center>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => updateEmployeeDetailsToReg()}
                    >
                      Update
                    </button>
                  </center>
                )}
              </>

            )}


          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
}
export default Confirm_Emp_OnRolls;
